import React, { Component } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReCAPTCHA from "react-google-recaptcha";
const common = require('./common');
const recaptchaRef = React.createRef();

const STATES_BY_COUNTRY = {
  // Asia
  "Afghanistan": [
    "Badakhshan", "Badghis", "Baghlan", "Balkh", "Bamyan", "Daykundi",
    "Farah", "Faryab", "Ghazni", "Ghor", "Helmand", "Herat",
    "Jowzjan", "Kabul", "Kandahar", "Kapisa", "Khost", "Kunar",
    "Laghman", "Lugar", "Nangarhar", "Nimruz", "Nuristan", "Oruzgan",
    "Paktia", "Paktika", "Panjshir", "Parwan", "Samangan", "Sar-e Pol",
    "Takhar", "Urozgan", "Wardak", "Zabul"
  ],
  "Armenia": [
    "Aragatsotn", "Ararat", "Armavir", "Gegharkunik", "Kotayk",
    "Lori", "Shirak", "Syunik", "Tavush", "Vayots Dzor", "Yerevan"
  ],
  "Azerbaijan": [
    "Absheron", "Agdam", "Agdash", "Aghjabadi", "Agstafa", "Agsu",
    "Astara", "Babek", "Baku", "Balakan", "Barda", "Beylagan",
    "Bilasuvar", "Dashkasan", "Fuzuli", "Gadabay", "Ganja", "Gobustan",
    "Goramboy", "Goychay", "Goygol", "Hajigabul", "Imishli", "Ismayilli",
    "Jabrayil", "Jalilabad", "Julfa", "Kalbajar", "Khachmaz", "Khankendi",
    "Khojali", "Khojavend", "Khizi", "Kangarli", "Lachin", "Lankaran",
    "Lerik", "Masally", "Mingachevir", "Naftalan", "Nakhchivan", "Neftchala",
    "Oghuz", "Ordubad", "Qabala", "Qakh", "Qazakh", "Quba",
    "Qubadli", "Qusar", "Saatly", "Sabirabad", "Sadarak", "Shabran",
    "Shahbuz", "Shaki", "Shamakhi", "Shamkir", "Shirvan", "Shusha",
    "Siazan", "Sumqayit", "Tartar", "Tovuz", "Ujar", "Yevlakh",
    "Zaqatala", "Zangilan", "Zardab"
  ],
  "Bahrain": [
    "Capital", "Central", "Muharraq", "Northern", "Southern"
  ],
  "Bangladesh": [
    "Barishal", "Chattogram", "Dhaka", "Khulna",
    "Mymensingh", "Rajshahi", "Rangpur", "Sylhet"
  ],
  "Bhutan": [
    "Bumthang", "Chhukha", "Dagana", "Gasa", "Haa", "Lhuentse",
    "Mongar", "Paro", "Pema Gatshel", "Punakha", "Samdrup Jongkhar",
    "Samtse", "Sarpang", "Thimphu", "Trashigang", "Trashi Yangtse",
    "Tirang", "Trongsa", "Tsirang", "Wangdue Phodrang", "Zhemgang"
  ],
  "British Indian Ocean Territory": [
    "Diego Garcia"
  ],
  "Brunei Darussalam": [
    "Belait", "Brunei-Muara", "Temburong", "Tutong"
  ],
  "Cambodia": [
    "Banteay Meanchey", "Battambang", "Kampong Cham", "Kampong Chhnang",
    "Kampong Speu", "Kampong Thom", "Kampot", "Kandal", "Kep",
    "Koh Kong", "Kratie", "Mondulkiri", "Oddar Meanchey", "Pailin",
    "Phnom Penh", "Preah Sihanouk", "Preah Vihear", "Prey Veng",
    "Pursat", "Ratanakiri", "Siem Reap", "Stung Treng", "Svay Rieng",
    "Takeo", "Tboung Khmum"
  ],
  "China": [
    "Anhui", "Beijing", "Chongqing", "Fujian", "Gansu", "Guangdong",
    "Guangxi", "Guizhou", "Hainan", "Hebei", "Heilongjiang", "Henan",
    "Hong Kong", "Hubei", "Hunan", "Inner Mongolia", "Jiangsu", "Jiangxi",
    "Jilin", "Liaoning", "Macau", "Ningxia", "Qinghai", "Shaanxi",
    "Shandong", "Shanghai", "Shanxi", "Sichuan", "Taiwan", "Tianjin",
    "Tibet", "Xinjiang", "Yunnan", "Zhejiang"
  ],
  "Christmas Island": [
    "Flying Fish Cove"
  ],
  "Cocos (Keeling) Islands": [
    "Home Island", "West Island"
  ],
  "Cyprus": [
    "Famagusta", "Kyrenia", "Larnaca", "Limassol", "Nicosia", "Paphos"
  ],
  "Georgia": [
    "Abkhazia", "Adjara", "Guria", "Imereti", "Kakheti",
    "Kvemo Kartli", "Mtskheta-Mtianeti", "Racha-Lechkhumi and Kvemo Svaneti",
    "Samegrelo-Zemo Svaneti", "Samtskhe-Javakheti", "Shida Kartli", "Tbilisi"
  ],
  "Hong Kong": [
    "Central and Western", "Eastern", "Islands", "Kowloon City",
    "Kwai Tsing", "Kwun Tong", "North", "Sai Kung", "Sha Tin",
    "Sham Shui Po", "Southern", "Tai Po", "Tsuen Wan", "Tuen Mun",
    "Wan Chai", "Wong Tai Sin", "Yau Tsim Mong", "Yuen Long"
  ],
  "India": [
    "Andaman and Nicobar Islands", "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chandigarh",
    "Chhattisgarh", "Dadra and Nagar Haveli and Daman and Diu", "Delhi", "Goa", "Gujarat", "Haryana",
    "Himachal Pradesh", "Jammu and Kashmir", "Jharkhand", "Karnataka", "Kerala", "Ladakh", "Lakshadweep",
    "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Puducherry",
    "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand",
    "West Bengal"
  ],
  "Indonesia": [
    "Aceh", "Bali", "Bangka Belitung Islands", "Banten", "Bengkulu",
    "Central Java", "Central Kalimantan", "Central Papua", "Central Sulawesi",
    "East Java", "East Kalimantan", "East Nusa Tenggara", "Gorontalo",
    "Highland Papua", "Jakarta", "Jambi", "Lampung", "Maluku",
    "North Kalimantan", "North Maluku", "North Sulawesi", "North Sumatra",
    "Papua", "Riau", "Riau Islands", "South Kalimantan", "South Papua",
    "South Sulawesi", "South Sumatra", "Southeast Sulawesi", "Southwest Papua",
    "West Java", "West Kalimantan", "West Nusa Tenggara", "West Papua",
    "West Sulawesi", "West Sumatra", "Yogyakarta"
  ],
  "Iran": [
    "Alborz", "Ardabil", "Bushehr", "Chaharmahal and Bakhtiari",
    "East Azerbaijan", "Fars", "Gilan", "Golestan", "Hamadan",
    "Hormozgan", "Ilam", "Isfahan", "Kerman", "Kermanshah",
    "Khuzestan", "Kohgiluyeh and Boyer-Ahmad", "Kurdistan", "Lorestan",
    "Markazi", "Mazandaran", "North Khorasan", "Qazvin", "Qom",
    "Razavi Khorasan", "Semnan", "Sistan and Baluchestan",
    "South Khorasan", "Tehran", "West Azerbaijan", "Yazd", "Zanjan"
  ],
  "Iraq": [
    "Al Anbar", "Babil", "Baghdad", "Basra", "Dhi Qar", "Al-Qādisiyyah",
    "Diyala", "Duhok", "Erbil", "Halabja", "Karbala", "Kirkuk",
    "Maysan", "Muthanna", "Najaf", "Ninawa", "Salah al-Din", "Sulaymaniyah",
    "Wasit"
  ],
  "Israel": [
    "Center", "Haifa", "Jerusalem", "North", "Southern", "Tel Aviv"
  ],
  "Japan": [
    "Aichi", "Akita", "Aomori", "Chiba", "Ehime", "Fukui", "Fukuoka",
    "Fukushima", "Gifu", "Gunma", "Hiroshima", "Hokkaido", "Hyogo",
    "Ibaraki", "Ishikawa", "Iwate", "Kagawa", "Kagoshima", "Kanagawa",
    "Kochi", "Kumamoto", "Kyoto", "Mie", "Miyagi", "Miyazaki",
    "Nagano", "Nagasaki", "Nara", "Niigata", "Oita", "Okayama",
    "Okinawa", "Osaka", "Saga", "Saitama", "Shiga", "Shimane",
    "Shizuoka", "Tochigi", "Tokushima", "Tokyo", "Tottori", "Toyama",
    "Wakayama", "Yamagata", "Yamaguchi", "Yamanashi"
  ],
  "Jordan": [
    "Ajloun", "Amman", "Aqaba", "Balqa", "Irbid", "Jerash",
    "Karak", "Ma'an", "Madaba", "Mafraq", "Tafilah", "Zarqa"
  ],
  "Kazakhstan": [
    "Abai", "Akmola", "Aktobe", "Almaty", "Almaty (City)", "Astana",
    "Atyrau", "East Kazakhstan", "Jambyl", "Jetisu", "Karaganda",
    "Kostanay", "Kyzylorda", "Mangystau", "North Kazakhstan",
    "Pavlodar", "Shymkent", "Ulytau", "West Kazakhstan", "Turkistan"
  ],
  "Korea, North": [
    "Chagang", "North Hamgyong", "South Hamgyong", "North Hwanghae",
    "South Hwanghae", "Kangwon", "North Pyongan", "South Pyongan",
    "Ryanggang", "Pyongyang", "Rason"
  ],
  "Korea, South": [
    "Busan", "Daegu", "Daejeon", "Gangwon", "Gwangju", "Gyeonggi",
    "North Gyeongsang", "South Gyeongsang", "Incheon", "Jeju",
    "North Jeolla", "South Jeolla", "Sejong", "Seoul", "Ulsan"
  ],
  "Kuwait": [
    "Al Ahmadi", "Al Asimah", "Al Farwaniyah", "Al Jahra", "Hawalli", "Mubarak Al-Kabeer"
  ],
  "Kyrgyzstan": [
    "Batken", "Bishkek", "Chuy", "Jalal-Abad", "Naryn", "Osh",
    "Osh (City)", "Talas", "Issyk-Kul"
  ],
  "Lao People's Democratic Republic": [
    "Attapeu", "Bokeo", "Bolikhamsai", "Champasak", "Houaphanh",
    "Khammouane", "Luang Namtha", "Luang Prabang", "Oudomxay",
    "Phongsaly", "Salavan", "Savannakhet", "Sekong", "Vientiane (Province)",
    "Vientiane (Prefecture)", "Sainyabuli", "Xaisomboun", "Xiangkhouang"
  ],
  "Lebanon": [
    "Akkar", "Baalbek-Hermel", "Beirut", "Beqaa", "Mount Lebanon",
    "Nabatieh", "North", "South"
  ],
  "Macao": [
    "Coloane", "Cotai", "Our Lady of Carmel", "St. Anthony",
    "St. Lawrence", "St. Lazarus", "St. Francis Xavier", "São Francisco"
  ],
  "Malaysia": [
    "Johor", "Kedah", "Kelantan", "Kuala Lumpur", "Labuan", "Melaka",
    "Negeri Sembilan", "Pahang", "Penang", "Perak", "Perlis", "Putrajaya",
    "Sabah", "Sarawak", "Selangor", "Terengganu"
  ],
  "Maldives": [
    "Addu City", "Ari Atoll", "Faafu Atoll", "Gaafu Alif Atoll",
    "Gaafu Dhaalu Atoll", "Gnaviyani Atoll", "Haa Alif Atoll", "Haa Dhaalu Atoll",
    "Laamu Atoll", "Lhaviyani Atoll", "Malé", "Meemu Atoll", "Noonu Atoll",
    "Raa Atoll", "Shaviyani Atoll", "Thaa Atoll", "Vaavu Atoll"
  ],
  "Mongolia": [
    "Arkhangai", "Bayan-Ölgii", "Bayankhongor", "Bulgan", "Darkhan-Uul",
    "Dornod", "Dornogovi", "Dundgovi", "Govi-Altai", "Govisümber",
    "Khentii", "Khovd", "Khövsgöl", "Ömnögovi", "Orkhon", "Övörkhangai",
    "Selenge", "Sükhbaatar", "Töv", "Ulaanbaatar", "Uvs", "Zavkhan"
  ],
  "Myanmar (Burma)": [
    "Ayeyarwady", "Bago", "Chin", "Kachin", "Kayah", "Kayin",
    "Magway", "Mandalay", "Mon", "Naypyidaw", "Rakhine",
    "Sagaing", "Shan", "Tanintharyi", "Yangon"
  ], 
  "Nepal": [
    "Bagmati", "Gandaki", "Karnali", "Koshi",
    "Lumbini", "Madhesh", "Sudurpashchim"
  ],
  "Oman": [
    "Ad Dakhiliyah", "Ad Dhahirah", "Al Batinah North", "Al Batinah South",
    "Al Buraimi", "Al Wusta", "Ash Sharqiyah North", "Ash Sharqiyah South",
    "Dhofar", "Masqat", "Musandam"
  ],
  "Pakistan": [
    "Azad Jammu & Kashmir", "Balochistan", "Gilgit-Baltistan",
    "Islamabad Capital Territory", "Khyber Pakhtunkhwa", "Punjab", "Sindh"
  ],
  "Palestine": [
    "Bethlehem", "Deir al-Balah", "Gaza", "Hebron", "Jenin",
    "Jericho", "Jerusalem", "Khan Yunis", "Nablus", "North Gaza",
    "Qalqilya", "Rafah", "Ramallah and Al-Bireh", "Salfit",
    "Tubas", "Tulkarm"
  ],
  "Philippines": [
    "Abra", "Agusan del Norte", "Agusan del Sur", "Aklan", "Albay",
    "Antique", "Apayao", "Aurora", "Basilan", "Bataan",
    "Batanes", "Batangas", "Benguet", "Biliran", "Bohol",
    "Bukidnon", "Bulacan", "Cagayan", "Camarines Norte", "Camarines Sur",
    "Camiguin", "Capiz", "Catanduanes", "Cavite", "Cebu",
    "Cotabato", "Davao de Oro", "Davao del Norte", "Davao del Sur", "Davao Occidental",
    "Davao Oriental", "Dinagat Islands", "Eastern Samar", "Guimaras", "Ifugao",
    "Ilocos Norte", "Ilocos Sur", "Iloilo", "Isabela", "Kalinga",
    "La Union", "Laguna", "Lanao del Norte", "Lanao del Sur", "Leyte",
    "Maguindanao del Norte", "Maguindanao del Sur", "Marinduque", "Masbate", "Metro Manila",
    "Misamis Occidental", "Misamis Oriental", "Mountain Province", "Negros Occidental", "Negros Oriental",
    "Northern Samar", "Nueva Ecija", "Nueva Vizcaya", "Occidental Mindoro", "Oriental Mindoro",
    "Palawan", "Pampanga", "Pangasinan", "Quezon", "Quirino",
    "Rizal", "Romblon", "Samar", "Sarangani", "Siquijor",
    "Sorsogon", "South Cotabato", "Southern Leyte", "Sultan Kudarat", "Sulu",
    "Surigao del Norte", "Surigao del Sur", "Tarlac", "Tawi-Tawi", "Zambales",
    "Zamboanga del Norte", "Zamboanga del Sur", "Zamboanga Sibugay"
  ],
  "Qatar": [
    "Al Daayen", "Al Khor", "Al Rayyan", "Al Shamal",
    "Al Wakrah", "Doha", "Madinat ash Shamal", "Umm Salal"
  ],
  "Russian Federation": [
    "Adygea", "Altai Republic", "Altai Krai", "Amur Oblast", "Arkhangelsk Oblast",
    "Astrakhan Oblast", "Bashkortostan", "Belgorod Oblast", "Bryansk Oblast", "Buryatia",
    "Chechen Republic", "Chelyabinsk Oblast", "Chukotka Autonomous Okrug", "Chuvashia",
    "Dagestan", "Ingushetia", "Irkutsk Oblast", "Jewish Autonomous Oblast", "Kabardino-Balkaria",
    "Kaliningrad Oblast", "Kalmykia", "Kaluga Oblast", "Kamchatka Krai", "Karachay-Cherkessia",
    "Karelia", "Kemerovo Oblast", "Khabarovsk Krai", "Khakassia", "Khanty-Mansi Autonomous Okrug",
    "Kirov Oblast", "Komi Republic", "Kostroma Oblast", "Krasnodar Krai", "Krasnoyarsk Krai",
    "Kurgan Oblast", "Kursk Oblast", "Leningrad Oblast", "Lipetsk Oblast", "Magadan Oblast",
    "Mari El", "Mordovia", "Moscow", "Moscow Oblast", "Murmansk Oblast",
    "Nenets Autonomous Okrug", "Nizhny Novgorod Oblast", "North Ossetia–Alania", "Novgorod Oblast", "Novosibirsk Oblast",
    "Omsk Oblast", "Orenburg Oblast", "Oryol Oblast", "Penza Oblast", "Perm Krai",
    "Primorsky Krai", "Pskov Oblast", "Rostov Oblast", "Ryazan Oblast", "Saint Petersburg",
    "Sakha (Yakutia)", "Sakhalin Oblast", "Samara Oblast", "Saratov Oblast", "Smolensk Oblast",
    "Stavropol Krai", "Sverdlovsk Oblast", "Tambov Oblast", "Tatarstan", "Tomsk Oblast",
    "Tula Oblast", "Tuva", "Tver Oblast", "Tyumen Oblast", "Udmurtia",
    "Ulyanovsk Oblast", "Vladimir Oblast", "Volgograd Oblast", "Vologda Oblast", "Voronezh Oblast",
    "Yamalo-Nenets Autonomous Okrug", "Yaroslavl Oblast", "Zabaykalsky Krai"
  ],
  "Saudi Arabia": [
    "'Asir", "Al Bahah", "Al Jawf", "Al Madinah", "Al Qassim",
    "Ha'il", "Jizan", "Makkah", "Najran", "Northern Borders",
    "Riyadh", "Eastern Province", "Tabuk"
  ],
  "Singapore": [
    "Central Singapore", "North East", "North West", "South East", "South West"
  ],
  "Sri Lanka": [
    "Central", "Eastern", "North Central", "North Western", "Northern",
    "Sabaragamuwa", "Southern", "Uva", "Western"
  ],
  "Syria": [
    "Al-Hasakah", "Aleppo", "Raqqa", "As-Suwayda", "Daraa",
    "Deir ez-Zor", "Hama", "Homs", "Idlib", "Latakia",
    "Quneitra", "Rif Dimashq", "Tartus", "Damascus"
  ],
  "Taiwan": [
    "Changhua", "Chiayi (City)", "Chiayi (County)", "Hsinchu (City)", "Hsinchu (County)",
    "Hualien", "Kaohsiung", "Keelung", "Kinmen", "Lienchiang (Matsu)",
    "Miaoli", "Nantou", "New Taipei", "Penghu", "Pingtung",
    "Taichung", "Tainan", "Taipei", "Taitung", "Taoyuan",
    "Yilan", "Yunlin"
  ],
  "Tajikistan": [
    "Dushanbe", "Gorno-Badakhshan", "Khatlon", "Regions of Republican Subordination", "Sughd"
  ],
  "Timor-Leste": [
    "Aileu", "Ainaro", "Atauro", "Baucau", "Bobonaro",
    "Cova Lima", "Dili", "Ermera", "Lautém", "Liquiçá",
    "Manatuto", "Manufahi", "Oecusse", "Viqueque"
  ],
  "Turkey (Türkiye)": [
    "Adana", "Adıyaman", "Afyonkarahisar", "Ağrı", "Aksaray", "Amasya", "Ankara", "Antalya", "Ardahan", "Artvin",
    "Aydın", "Balıkesir", "Bartın", "Batman", "Bayburt", "Bilecik", "Bingöl", "Bitlis", "Bolu", "Burdur",
    "Bursa", "Çanakkale", "Çankırı", "Çorum", "Denizli", "Diyarbakır", "Düzce", "Edirne", "Elazığ", "Erzincan",
    "Erzurum", "Eskişehir", "Gaziantep", "Giresun", "Gümüşhane", "Hakkâri", "Hatay", "Iğdır", "Isparta", "İstanbul",
    "İzmir", "Kahramanmaraş", "Karabük", "Karaman", "Kars", "Kastamonu", "Kayseri", "Kırıkkale", "Kırklareli", "Kırşehir",
    "Kilis", "Kocaeli", "Konya", "Kütahya", "Malatya", "Manisa", "Mardin", "Mersin", "Muğla", "Muş",
    "Nevşehir", "Niğde", "Ordu", "Osmaniye", "Rize", "Sakarya", "Samsun", "Siirt", "Sinop", "Sivas",
    "Şanlıurfa", "Şırnak", "Tekirdağ", "Tokat", "Trabzon", "Tunceli", "Uşak", "Van", "Yalova", "Yozgat",
    "Zonguldak"
  ],
  "Turkmenistan": [
    "Ahal", "Ashgabat", "Balkan", "Dashoguz", "Lebap", "Mary"
  ],
  "United Arab Emirates": [
    "Abu Dhabi", "Ajman", "Dubai", "Fujairah", "Ras Al Khaimah", "Sharjah", "Umm Al Quwain"
  ],
  "Uzbekistan": [
    "Andijan", "Bukhara", "Fergana", "Jizzakh", "Karakalpakstan", "Kashkadarya",
    "Khorezm", "Namangan", "Navoiy", "Samarkand", "Tashkent (City)", "Tashkent (Region)",
    "Surkhandarya", "Syrdarya"
  ],
  "Yemen": [
    "'Adan", "'Amran", "Abyan", "Al Bayda'", "Al Hudaydah",
    "Al Jawf", "Al Mahrah", "Al Mahwit", "Amanat al 'Asimah (Sana'a City)",
    "Dhamar", "Hadramaut", "Hajjah", "Ibb", "Lahij",
    "Ma'rib", "Raymah", "Sa'dah", "Sana'a (Governorate)", "Shabwah",
    "Socotra", "Ta'izz"
  ],
  // Europe
  "Åland Islands": [
    "Brändö", "Eckerö", "Finström", "Föglö", "Geta",
    "Hammarland", "Jomala", "Kumlinge", "Kökar", "Lemland",
    "Lumparland", "Mariehamn", "Saltvik", "Sottunga", "Sund",
    "Vårdö"
  ],
  "Albania": [
    "Berat", "Dibër", "Durrës", "Elbasan", "Fier",
    "Gjirokastër", "Korçë", "Kukës", "Lezhë", "Shkodër",
    "Tirana", "Vlorë"
  ],
  "Andorra": [
    "Andorra la Vella", "Canillo", "Encamp", "Escaldes-Engordany",
    "La Massana", "Ordino", "Sant Julià de Lòria"
  ],
  "Austria": [
    "Burgenland", "Carinthia", "Lower Austria", "Salzburg",
    "Styria", "Tyrol", "Upper Austria", "Vienna", "Vorarlberg"
  ],
  "Belarus": [
    "Brest", "Gomel", "Grodno", "Minsk (City)", "Minsk (Region)",
    "Mogilev", "Vitebsk"
  ],
  "Belgium": [
    "Antwerp", "Brussels-Capital Region", "East Flanders", "Flemish Brabant",
    "Hainaut", "Liège", "Limburg", "Luxembourg", "Namur",
    "Walloon Brabant", "West Flanders"
  ],
  "Bosnia and Herzegovina": [
    "Bosnian Podrinje", "Brčko District", "Central Bosnia", "Canton 10",
    "Herzegovina-Neretva", "Posavina", "Republika Srpska", "Sarajevo",
    "Tuzla", "Una-Sana", "West Herzegovina", "Zenica-Doboj"
  ],
  "Bulgaria": [
    "Blagoevgrad", "Burgas", "Dobrich", "Gabrovo", "Haskovo",
    "Kardzhali", "Kyustendil", "Lovech", "Montana", "Pazardzhik",
    "Pernik", "Pleven", "Plovdiv", "Razgrad", "Ruse",
    "Shumen", "Silistra", "Sliven", "Smolyan", "Sofia (City)",
    "Sofia (Province)", "Stara Zagora", "Targovishte", "Varna", "Veliko Tarnovo",
    "Vidin", "Vratsa", "Yambol"
  ],
  "Croatia": [
    "Bjelovar-Bilogora", "Brod-Posavina", "Dubrovnik-Neretva", "Istria", "Karlovac",
    "Koprivnica-Križevci", "Krapina-Zagorje", "Lika-Senj", "Međimurje", "Osijek-Baranja",
    "Požega-Slavonia", "Primorje-Gorski Kotar", "Sisak-Moslavina", "Split-Dalmatia", "Šibenik-Knin",
    "Varaždin", "Virovitica-Podravina", "Vukovar-Srijem", "Zadar", "Zagreb (City)",
    "Zagreb (County)"
  ],
  "Czech Republic": [
    "Central Bohemian", "Hradec Králové", "Karlovy Vary", "Liberec", "Moravian-Silesian",
    "Olomouc", "Pardubice", "Plzeň", "Prague", "South Bohemian",
    "South Moravian", "Ústí nad Labem", "Vysočina", "Zlín"
  ],
  "Denmark": [
    "Capital Region of Denmark", "Central Denmark Region", "North Denmark Region",
    "Region Zealand", "Region of Southern Denmark"
  ],
  "Estonia": [
    "Harju", "Hiiu", "Ida-Viru", "Jõgeva", "Järva",
    "Lääne", "Lääne-Viru", "Põlva", "Pärnu", "Rapla",
    "Saare", "Tartu", "Valga", "Viljandi", "Võru"
  ],
  "Faroe Islands": [
    "Eysturoy", "Norðoyar", "Sandoy", "Streymoy", "Suðuroy", "Vágar"
  ],
  "Finland": [
    "Central Finland", "Central Ostrobothnia", "Kainuu", "Kanta-Häme", "Kymenlaakso",
    "Lapland", "North Karelia", "North Ostrobothnia", "North Savo", "Päijät-Häme",
    "Pirkanmaa", "Ostrobothnia", "Satakunta", "South Karelia", "South Ostrobothnia",
    "South Savo", "Southwest Finland", "Uusimaa", "Åland"
  ],
  "France": [
    "Auvergne-Rhône-Alpes", "Bourgogne-Franche-Comté", "Brittany", "Centre-Val de Loire",
    "Corsica", "Grand Est", "Hauts-de-France", "Île-de-France", "Normandy",
    "Nouvelle-Aquitaine", "Occitanie", "Pays de la Loire", "Provence-Alpes-Côte d'Azur"
  ],
  "Germany": [
    "Baden-Württemberg", "Bavaria", "Berlin", "Brandenburg", "Bremen",
    "Hamburg", "Hesse", "Lower Saxony", "Mecklenburg-Vorpommern", "North Rhine-Westphalia",
    "Rhineland-Palatinate", "Saarland", "Saxony", "Saxony-Anhalt", "Schleswig-Holstein",
    "Thuringia"
  ],
  "Gibraltar": [
    "Gibraltar"
  ],
  "Greece": [
    "Attica", "Central Greece", "Central Macedonia", "Crete", "Eastern Macedonia and Thrace",
    "Epirus", "Ionian Islands", "North Aegean", "Peloponnese", "South Aegean",
    "Thessaly", "Western Greece", "Western Macedonia"
  ],
  "Guernsey": [
    "Castel", "Forest", "Notre Dame du Rosaire", "St Andrew", "St Martin",
    "St Peter Port", "St Pierre du Bois", "St Sampson", "St Saviour", "Torteval",
    "Vale"
  ],
  "Hungary": [
    "Bács-Kiskun", "Baranya", "Békés", "Borsod-Abaúj-Zemplén", "Budapest",
    "Csongrád-Csanád", "Fejér", "Győr-Moson-Sopron", "Hajdú-Bihar", "Heves",
    "Jász-Nagykun-Szolnok", "Komárom-Esztergom", "Nógrád", "Pest", "Somogy",
    "Szabolcs-Szatmár-Bereg", "Tolna", "Vas", "Veszprém", "Zala"
  ],
  "Iceland": [
    "Capital Region", "Southern Peninsula", "Western Region", "Westfjords",
    "Northwestern Region", "Northeastern Region", "Eastern Region", "Southern Region"
  ],
  "Ireland": [
    "Carlow", "Cavan", "Clare", "Cork", "Donegal",
    "Dublin", "Galway", "Kerry", "Kildare", "Kilkenny",
    "Laois", "Leitrim", "Limerick", "Longford", "Louth",
    "Mayo", "Meath", "Monaghan", "Offaly", "Roscommon",
    "Sligo", "Tipperary", "Waterford", "Westmeath", "Wexford",
    "Wicklow"
  ],
  "Isle of Man": [
    "Ayre", "Glenfaba", "Garff", "Michael", "Middle", "Rushen"
  ],
  "Italy": [
    "Abruzzo", "Aosta Valley", "Apulia", "Basilicata", "Calabria",
    "Campania", "Emilia-Romagna", "Friuli Venezia Giulia", "Lazio", "Liguria",
    "Lombardy", "Marche", "Molise", "Piedmont", "Sardinia",
    "Sicily", "Trentino-South Tyrol", "Tuscany", "Umbria", "Veneto"
  ],
  "Jersey": [
    "Grouville", "St Brelade", "St Clement", "St Helier", "St John",
    "St Lawrence", "St Martin", "St Mary", "St Ouen", "St Peter",
    "St Saviour", "Trinity"
  ],
  "Kosovo": [
    "Ferizaj", "Gjakova", "Gjilan", "Mitrovica", "Peja",
    "Pristina", "Prizren"
  ],
  "Latvia": [
    "Aizkraukle", "Alūksne", "Ādaži", "Balvi", "Bauska",
    "Cēsis", "Daugavpils (City)", "Daugavpils (District)", "Dobele", "Gulbene",
    "Jelgava (City)", "Jelgava (District)", "Jēkabpils", "Jūrmala", "Ķekava",
    "Krāslava", "Kuldīga", "Liepāja (City)", "Līvāni", "Ludza",
    "Madona", "Mārupe", "Ogre", "Olaine", "Preiļi",
    "Rēzekne (City)", "Rēzekne (District)", "Rīga", "Ropaži", "Salaspils",
    "Saldus", "Saulkrasti", "Sigulda", "Smiltene", "Talsi",
    "Tukums", "Valka", "Valmiera", "Ventspils (City)", "Ventspils (District)"
  ],
  "Liechtenstein": [
    "Balzers", "Eschen", "Gamprin", "Mauren", "Planken",
    "Ruggell", "Schaan", "Schellenberg", "Triesen", "Triesenberg",
    "Vaduz"
  ],
  "Lithuania": [
    "Alytus", "Kaunas", "Klaipėda", "Marijampolė", "Panevėžys",
    "Šiauliai", "Tauragė", "Telšiai", "Utena", "Vilnius"
  ],
  "Luxembourg": [
    "Capellen", "Clervaux", "Diekirch", "Echternach", "Esch-sur-Alzette",
    "Grevenmacher", "Luxembourg", "Mersch", "Redange", "Remich",
    "Vianden", "Wiltz"
  ],
  "Macedonia North": [
    "Eastern", "Northeastern", "Pelagonija", "Polog", "Skopje",
    "Southeastern", "Southwestern", "Vardar"
  ],
  "Malta": [
    "Central", "Gozo", "Northern", "Northern Harbour", "Southern Harbour",
    "South Eastern"
  ],
  "Moldova": [
    "Anenii Noi", "Bălți", "Basarabeasca", "Briceni", "Cahul",
    "Călărași", "Cantemir", "Căușeni", "Chișinău", "Cimișlia",
    "Criuleni", "Dondușeni", "Drochia", "Dubăsari", "Edineț",
    "Fălești", "Florești", "Gagauzia", "Glodeni", "Hîncești",
    "Ialoveni", "Leova", "Nisporeni", "Ocnița", "Orhei",
    "Rezina", "Rîșcani", "Sîngerei", "Șoldănești", "Soroca",
    "Ștefan Vodă", "Strășeni", "Taraclia", "Telenești", "Transnistria",
    "Ungheni"
  ],
  "Monaco": [
    "Fontvieille", "La Condamine", "La Colle", "La Gare", "Le Portier",
    "Les Moneghetti", "Les Révoires", "Monaco-Ville", "Monte Carlo", "Saint Roman"
  ],
  "Montenegro": [
    "Andrijevica", "Bar", "Berane", "Bijelo Polje", "Budva",
    "Cetinje", "Danilovgrad", "Gusinje", "Herceg Novi", "Kolašin",
    "Kotor", "Mojkovac", "Nikšić", "Petnjica", "Plav",
    "Pljevlja", "Plužine", "Podgorica", "Rožaje", "Šavnik",
    "Tivat", "Tuzi", "Ulcinj", "Žabljak", "Zeta"
  ],
  "Netherlands": [
    "Drenthe", "Flevoland", "Friesland", "Gelderland", "Groningen",
    "Limburg", "North Brabant", "North Holland", "Overijssel", "South Holland",
    "Utrecht", "Zeeland"
  ],
  "Norway": [
    "Agder", "Akershus", "Buskerud", "Finnmark", "Innlandet",
    "Møre og Romsdal", "Nordland", "Oslo", "Østfold", "Rogaland",
    "Telemark", "Troms", "Trøndelag", "Vestfold", "Vestland"
  ],
  "Poland": [
    "Greater Poland", "Kuyavian-Pomeranian", "Lesser Poland", "Łódź", "Lower Silesian",
    "Lublin", "Lubusz", "Masovian", "Opole", "Podlaskie",
    "Pomeranian", "Silesian", "Subcarpathian", "Holy Cross", "Warmian-Masurian",
    "West Pomeranian"
  ],
  "Portugal": [
    "Azores", "Aveiro", "Beja", "Braga", "Bragança",
    "Castelo Branco", "Coimbra", "Évora", "Faro", "Guarda",
    "Leiria", "Lisbon", "Madeira", "Portalegre", "Porto",
    "Santarém", "Setúbal", "Viana do Castelo", "Vila Real", "Viseu"
  ],
  "Romania": [
    "Alba", "Arad", "Argeș", "Bacău", "Bihor",
    "Bistrița-Năsăud", "Botoșani", "Brașov", "Brăila", "Bucharest",
    "Buzău", "Caraș-Severin", "Călărași", "Cluj", "Constanța",
    "Covasna", "Dâmbovița", "Dolj", "Galați", "Giurgiu",
    "Gorj", "Harghita", "Hunedoara", "Ialomița", "Iași",
    "Ilfov", "Maramureș", "Mehedinți", "Mureș", "Neamț",
    "Olt", "Prahova", "Satu Mare", "Sălaj", "Sibiu",
    "Suceava", "Teleorman", "Timiș", "Tulcea", "Vaslui",
    "Vâlcea", "Vrancea"
  ],
  "San Marino": [
    "Acquaviva", "Borgo Maggiore", "Chiesanuova", "Domagnano", "Faetano",
    "Fiorentino", "Montegiardino", "San Marino City", "Serravalle"
  ],
  "Serbia": [
    "Belgrade", "Bor", "Braničevo", "Central Banat", "Danube",
    "Jablanica", "Kolubara", "Mačva", "Moravica", "Nišava",
    "North Banat", "North Bačka", "Pčinja", "Pirot", "Rasina",
    "Raška", "South Banat", "South Bačka", "Srem", "Šumadija",
    "Toplica", "West Bačka", "Zlatibor", "Zaječar"
  ],
  "Serbia and Montenegro": [
    "Montenegro", "Serbia"
  ],
  "Slovakia": [
    "Banská Bystrica", "Bratislava", "Košice", "Nitra",
    "Prešov", "Trenčín", "Trnava", "Žilina"
  ],
  "Slovenia": [
    "Carinthia", "Central Slovenia", "Central Sava", "Drava",
    "Goriška", "Littoral-Inner Carniola", "Mura", "Lower Sava",
    "Upper Carniola", "Southeast Slovenia", "Savinja", "Obalno-kraška"
  ],
  "Spain": [
    "Andalusia", "Aragon", "Asturias", "Balearic Islands", "Basque Country",
    "Canary Islands", "Cantabria", "Castile and León", "Castile-La Mancha", "Catalonia",
    "Ceuta", "Extremadura", "Galicia", "La Rioja", "Madrid",
    "Melilla", "Murcia", "Navarre", "Valencia"
  ],
  "Svalbard and Jan Mayen": [
    "Jan Mayen", "Svalbard"
  ],
  "Sweden": [
    "Blekinge", "Dalarna", "Gävleborg", "Gotland", "Halland",
    "Jämtland", "Jönköping", "Kalmar", "Kronoberg", "Norrbotten",
    "Örebro", "Östergötland", "Skåne", "Södermanland", "Stockholm",
    "Uppsala", "Värmland", "Västerbotten", "Västernorrland", "Västmanland",
    "Västra Götaland"
  ],
  "Switzerland": [
    "Aargau", "Appenzell Ausserrhoden", "Appenzell Innerrhoden", "Basel-Landschaft", "Basel-Stadt",
    "Bern", "Fribourg", "Geneva", "Glarus", "Grisons",
    "Jura", "Lucerne", "Neuchâtel", "Nidwalden", "Obwalden",
    "Schaffhausen", "Schwyz", "Solothurn", "St. Gallen", "Thurgau",
    "Ticino", "Uri", "Valais", "Vaud", "Zug",
    "Zurich"
  ],
  "Ukraine": [
    "Cherkasy", "Chernihiv", "Chernivtsi", "Crimea", "Dnipropetrovsk",
    "Donetsk", "Ivano-Frankivsk", "Kharkiv", "Kherson", "Khmelnytskyi",
    "Kirovohrad", "Kyiv (City)", "Kyiv (Oblast)", "Luhansk", "Lviv",
    "Mykolaiv", "Odesa", "Poltava", "Rivne", "Sevastopol",
    "Sumy", "Ternopil", "Vinnytsia", "Volyn", "Zakarpattia",
    "Zaporizhzhia", "Zhytomyr"
  ],
  "United Kingdom": [
    "England", "Northern Ireland", "Scotland", "Wales"
  ],
  "Vatican City Holy See": [
    "Vatican City"
  ],
  // Africa
  "Algeria": [
    "Adrar", "Chlef", "Laghouat", "Oum El Bouaghi", "Batna",
    "Béjaïa", "Biskra", "Béchar", "Blida", "Bouira",
    "Tamanrasset", "Tébessa", "Tlemcen", "Tiaret", "Tizi Ouzou",
    "Algiers", "Djelfa", "Jijel", "Sétif", "Saïda",
    "Skikda", "Sidi Bel Abbès", "Annaba", "Guelma", "Constantine",
    "Médéa", "Mostaganem", "M'Sila", "Mascara", "Ouargla",
    "Oran", "El Bayadh", "Illizi", "Bordj Bou Arréridj", "Boumerdès",
    "El Tarf", "Tindouf", "Tissemsilt", "El Oued", "Khenchela",
    "Souk Ahras", "Tipaza", "Mila", "Aïn Defla", "Naâma",
    "Aïn Témouchent", "Ghardaïa", "Relizane", "Timimoun", "Bordj Badji Mokhtar",
    "Ouled Djellal", "Béni Abbès", "In Salah", "In Guezzam", "Touggourt",
    "Djanet", "El M'Ghair", "El Menia"
  ],
  "Angola": [
    "Bengo", "Benguela", "Bié", "Cabinda", "Cuando Cubango",
    "Cuanza Norte", "Cuanza Sul", "Cunene", "Huambo", "Huíla",
    "Luanda", "Lunda Norte", "Lunda Sul", "Malanje", "Moxico",
    "Namibe", "Uíge", "Zaire"
  ],
  "Benin": [
    "Alibori", "Atakora", "Atlantique", "Borgou", "Collines",
    "Donga", "Kouffo", "Littoral", "Mono", "Ouémé",
    "Plateau", "Zou"
  ],
  "Botswana": [
    "Central", "Chobe", "Ghanzi", "Kgalagadi", "Kgatleng",
    "Kweneng", "North-East", "North-West", "South-East", "Southern"
  ],
  "Burkina Faso": [
    "Balé", "Bam", "Banwa", "Bazèga", "Bougouriba",
    "Boulgou", "Boulkiemdé", "Comoé", "Ganzourgou", "Gnagna",
    "Gourma", "Houet", "Ioba", "Kadiogo", "Kénédougou",
    "Komondjari", "Kompienga", "Kossi", "Koulpélogo", "Kouritenga",
    "Kourwéogo", "Léraba", "Loroum", "Mouhoun", "Nahouri",
    "Namentenga", "Nayala", "Noumbiel", "Oubritenga", "Oudalan",
    "Passoré", "Poni", "Sanguié", "Sanmatenga", "Séno",
    "Sissili", "Soum", "Sourou", "Tapoa", "Tuy",
    "Yagha", "Yatenga", "Ziro", "Zondoma", "Zoundwéogo"
  ],
  "Burundi": [
    "Bubanza", "Bujumbura Mairie", "Bujumbura Rural", "Bururi", "Cankuzo",
    "Cibitoke", "Gitega", "Karuzi", "Kayanza", "Kirundo",
    "Makamba", "Muramvya", "Muyinga", "Mwaro", "Ngozi",
    "Rumonge", "Rutana", "Ruyigi"
  ],
  "Cabo Verde": [
    "Boa Vista", "Brava", "Maio", "Mosteiros", "Paúl",
    "Porto Novo", "Praia", "Ribeira Brava", "Ribeira Grande", "Ribeira Grande de Santiago",
    "Sal", "Santa Catarina", "Santa Catarina do Fogo", "Santa Cruz", "São Domingos",
    "São Filipe", "São Lourenço dos Órgãos", "São Miguel", "São Salvador do Mundo", "São Vicente",
    "Tarrafal", "Tarrafal de São Nicolau"
  ],
  "Cameroon": [
    "Adamawa", "Central", "East", "Far North", "Littoral",
    "North", "North-West", "South", "South-West", "West"
  ],
  "Central African Republic": [
    "Bamingui-Bangoran", "Bangui", "Basse-Kotto", "Haute-Kotto", "Haut-Mbomou",
    "Kémo", "Lobaye", "Mambéré-Kadéï", "Mbomou", "Nana-Grébizi",
    "Nana-Mambéré", "Ombella-M'Poko", "Ouaka", "Ouham", "Ouham-Pendé",
    "Sangha-Mbaéré", "Vakaga"
  ],
  "Chad": [
    "Batha", "Borkou", "Chari-Baguirmi", "Ennedi-Est", "Ennedi-Ouest",
    "Guéra", "Hadjer-Lamis", "Kanem", "Lac", "Logone Occidental",
    "Logone Oriental", "Mandoul", "Mayo-Kebbi Est", "Mayo-Kebbi Ouest", "Moyen-Chari",
    "N'Djamena", "Ouaddaï", "Salamat", "Sila", "Tandjilé",
    "Tibesti", "Wadi Fira"
  ],
  "Comoros": [
    "Anjouan", "Grande Comore", "Mohéli"
  ],
  "Congo": [
    "Bouenza", "Brazzaville", "Cuvette", "Cuvette-Ouest", "Kouilou",
    "Lékoumou", "Likouala", "Niari", "Plateaux", "Pointe-Noire",
    "Pool", "Sangha"
  ],
  "Congo, Democratic Republic of the": [
    "Bas-Uélé", "Equateur", "Haut-Katanga", "Haut-Lomami", "Haut-Uélé",
    "Ituri", "Kasaï", "Kasaï-Central", "Kasaï-Oriental", "Kinshasa",
    "Kongo-Central", "Kwango", "Kwilu", "Lomami", "Lualaba",
    "Mai-Ndombe", "Maniema", "Mongala", "Nord-Kivu", "Nord-Ubangi",
    "Sankuru", "Sud-Kivu", "Sud-Ubangi", "Tanganyika", "Tshopo",
    "Tshuapa"
  ],
  "Côte d'Ivoire": [
    "Abidjan", "Bas-Sassandra", "Comoé", "Denguélé", "Gôh-Djiboua",
    "Lacs", "Lagunes", "Montagnes", "Sassandra-Marahoué", "Savanes",
    "Vallée du Bandama", "Woroba", "Yamoussoukro", "Zanzan"
  ],
  "Djibouti": [
    "Ali Sabieh", "Arta", "Dikhil", "Djibouti", "Obock", "Tadjourah"
  ],
  "Egypt": [
    "Alexandria", "Aswan", "Asyut", "Beheira", "Beni Suef",
    "Cairo", "Dakahlia", "Damietta", "Faiyum", "Gharbia",
    "Giza", "Ismailia", "Kafr El Sheikh", "Luxor", "Matrouh",
    "Minya", "Monufia", "New Valley", "North Sinai", "Port Said",
    "Qalyubia", "Qena", "Red Sea", "Sharqia", "Sohag",
    "South Sinai", "Suez"
  ],
  "Equatorial Guinea": [
    "Annobón", "Bioko Norte", "Bioko Sur", "Centro Sur", "Djibloho",
    "Kié-Ntem", "Litoral", "Wele-Nzas"
  ],
  "Eritrea": [
    "Anseba", "Central (Maekel)", "Gash-Barka", "Northern Red Sea (Semienawi Keyih Bahri)",
    "Southern (Debub)", "Southern Red Sea (Debubawi Keyih Bahri)"
  ],
  "Eswatini (Swaziland)": [
    "Hhohho", "Lubombo", "Manzini", "Shiselweni"
  ],
  "Ethiopia": [
    "Addis Ababa", "Afar", "Amhara", "Benishangul-Gumuz", "Dire Dawa",
    "Gambela", "Harari", "Oromia", "Sidama", "Somali",
    "South West Ethiopia Peoples' Region", "Southern Nations, Nationalities, and Peoples' Region", "Tigray"
  ],
  "Gabon": [
    "Estuaire", "Haut-Ogooué", "Moyen-Ogooué", "Ngounié", "Nyanga",
    "Ogooué-Ivindo", "Ogooué-Lolo", "Ogooué-Maritime", "Woleu-Ntem"
  ],
  "Gambia": [
    "Banjul", "Central River", "Lower River", "North Bank", "Upper River",
    "West Coast"
  ],
  "Ghana": [
    "Ahafo", "Ashanti", "Bono", "Bono East", "Central",
    "Eastern", "Greater Accra", "North East", "Northern", "Oti",
    "Savannah", "Upper East", "Upper West", "Volta", "Western",
    "Western North"
  ],
  "Guinea": [
    "Boké", "Conakry", "Faranah", "Kankan", "Kindia",
    "Labé", "Mamou", "N'Zérékoré"
  ],
  "Guinea-Bissau": [
    "Bafatá", "Biombo", "Bissau", "Bolama", "Cacheu",
    "Gabú", "Oio", "Quinara", "Tombali"
  ],
  "Kenya": [
    "Baringo", "Bomet", "Bungoma", "Busia", "Elgeyo-Marakwet",
    "Embu", "Garissa", "Homa Bay", "Isiolo", "Kajiado",
    "Kakamega", "Kericho", "Kiambu", "Kilifi", "Kirinyaga",
    "Kisii", "Kisumu", "Kitui", "Kwale", "Laikipia",
    "Lamu", "Machakos", "Makueni", "Mandera", "Marsabit",
    "Meru", "Migori", "Mombasa", "Murang'a", "Nairobi",
    "Nakuru", "Nandi", "Narok", "Nyamira", "Nyandarua",
    "Nyeri", "Samburu", "Siaya", "Taita-Taveta", "Tana River",
    "Tharaka-Nithi", "Trans Nzoia", "Turkana", "Uasin Gishu", "Vihiga",
    "Wajir", "West Pokot"
  ],
  "Lesotho": [
    "Berea", "Butha-Buthe", "Leribe", "Mafeteng", "Maseru",
    "Mohale's Hoek", "Mokhotlong", "Qacha's Nek", "Quthing", "Thaba-Tseka"
  ],
  "Liberia": [
    "Bomi", "Bong", "Gbarpolu", "Grand Bassa", "Grand Cape Mount",
    "Grand Gedeh", "Grand Kru", "Lofa", "Margibi", "Maryland",
    "Montserrado", "Nimba", "River Cess", "River Gee", "Sinoe"
  ],
  "Libya": [
    "Al Wahat", "Benghazi", "Derna", "Ghat", "Jabal al Gharbi",
    "Jabal al Akhdar", "Jafara", "Jufra", "Kufra", "Marj",
    "Misrata", "Murzuq", "Nalut", "Nuqat al Khams", "Sabha",
    "Sirte", "Tripoli", "Wadi al Hayaa", "Wadi al Shatii", "Zawiya"
  ],
  "Madagascar": [
    "Alaotra-Mangoro", "Amoron'i Mania", "Analamanga", "Analanjirofo", "Androy",
    "Anosy", "Atsimo-Andrefana", "Atsimo-Atsinanana", "Atsinanana", "Betsiboka",
    "Boeny", "Bongolava", "Diana", "Haute Matsiatra", "Ihorombe",
    "Itasy", "Melaky", "Menabe", "Sava", "Sofia",
    "Vakinankaratra", "Vatovavy", "Fitovinany"
  ],
  "Malawi": [
    "Balaka", "Blantyre", "Chikwawa", "Chiradzulu", "Chitipa",
    "Dedza", "Dowa", "Karonga", "Kasungu", "Likoma",
    "Lilongwe", "Machinga", "Mangochi", "Mchinji", "Mulanje", "Mwanza",
    "Mzimba", "Nkhata Bay", "Nkhotakota", "Nsanje", "Ntcheu",
    "Ntchisi", "Phalombe", "Rumphi", "Salima", "Thyolo",
    "Zomba"
  ],
  "Mali": [
    "Bandiagara", "Bougouni", "Douentza", "Gao", "Kayes",
    "Kidal", "Koulikoro", "Koutiala", "Mopti", "Nioro",
    "Ségou", "Sikasso", "Taoudénit", "Tombouctou", "San",
    "Dioïla", "Bamako"
  ],
  "Mauritania": [
    "Adrar", "Assaba", "Brakna", "Dakhlet Nouadhibou", "Gorgol",
    "Guidimaka", "Hodh Ech Chargui", "Hodh El Gharbi", "Inchiri", "Nouakchott-Nord",
    "Nouakchott-Ouest", "Nouakchott-Sud", "Tagant", "Tiris Zemmour", "Trarza"
  ],
  "Mauritius": [
    "Agalega Islands", "Black River", "Cargados Carajos", "Flacq", "Grand Port",
    "Moka", "Pamplemousses", "Plaines Wilhems", "Port Louis", "Riviere du Rempart",
    "Rodrigues", "Savanne"
  ],
  "Mayotte": [
    "Bandrele", "Bandraboua", "Boueni", "Chiconi", "Chirongui",
    "Dembeni", "Dzaoudzi", "Kani-Keli", "Koungou", "Mamoudzou",
    "Mtsamboro", "M'Tsangamouji", "Ouangani", "Pamplona", "Sada",
    "Tsingoni"
  ], 
  "Morocco": [
    "Béni Mellal-Khénifra", "Casablanca-Settat", "Dakhla-Oued Ed-Dahab",
    "Drâa-Tafilalet", "Fès-Meknès", "Guelmim-Oued Noun", "Laâyoune-Sakia El Hamra",
    "Marrakesh-Safi", "Oriental", "Rabat-Salé-Kénitra", "Souss-Massa",
    "Tanger-Tetouan-Al Hoceima"
  ], 
  "Mozambique": [
    "Cabo Delgado", "Gaza", "Inhambane", "Manica", "Maputo (City)",
    "Maputo (Province)", "Nampula", "Niassa", "Sofala", "Tete",
    "Zambezia"
  ], 
  "Namibia": [
    "Erongo", "Hardap", "Karas", "Kavango East", "Kavango West",
    "Khomas", "Kunene", "Ohangwena", "Omaheke", "Omusati",
    "Oshana", "Oshikoto", "Otjozondjupa", "Zambezi"
  ], 
  "Niger": [
    "Agadez", "Diffa", "Dosso", "Maradi", "Niamey",
    "Tahoua", "Tillabéri", "Zinder"
  ], 
  "Nigeria": [
    "Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi",
    "Bayelsa", "Benue", "Borno", "Cross River", "Delta",
    "Ebonyi", "Edo", "Ekiti", "Enugu", "Federal Capital Territory",
    "Gombe", "Imo", "Jigawa", "Kaduna", "Kano",
    "Katsina", "Kebbi", "Kogi", "Kwara", "Lagos",
    "Nasarawa", "Niger", "Ogun", "Ondo", "Osun",
    "Oyo", "Plateau", "Rivers", "Sokoto", "Taraba",
    "Yobe", "Zamfara"
  ], 
  "Reunion": [
    "Les Avirons", "Bras-Panon", "Cilaos", "Entre-Deux", "L'Étang-Salé",
    "La Plaine-des-Palmistes", "Petite-Île", "Le Port", "La Possession", "Saint-André",
    "Saint-Benoît", "Saint-Denis", "Saint-Joseph", "Saint-Leu", "Saint-Louis",
    "Saint-Paul", "Saint-Pierre", "Saint-Philippe", "Sainte-Marie", "Sainte-Rose",
    "Sainte-Suzanne", "Salazie", "Le Tampon", "Les Trois-Bassins"
  ], 
  "Rwanda": [
    "Kigali", "Eastern (Iburasirazuba)", "Northern (Amajyaruguru)",
    "Southern (Amajyepfo)", "Western (Iburengerazuba)"
  ], 
  "Saint Helena": [
    "Ascension", "Saint Helena", "Tristan da Cunha"
  ], 
  "Sao Tome and Principe": [
    "Água Grande", "Cantagalo", "Caué", "Lembá", "Lobata",
    "Mé-Zóchi", "Príncipe"
  ],
  "Senegal": [
    "Dakar", "Diourbel", "Fatick", "Kaffrine", "Kaolack",
    "Kédougou", "Kolda", "Louga", "Matam", "Sédhiou",
    "Saint-Louis", "Tambacounda", "Thiès", "Ziguinchor"
  ],
  "Seychelles": [
    "Anse aux Pins", "Anse Boileau", "Anse Etoile", "Anse Royale", "Au Cap",
    "Baie Lazare", "Baie Sainte Anne", "Beau Vallon", "Bel Air", "Bel Ombre",
    "Cascade", "Glacis", "Grand'Anse Mahé", "Grand'Anse Praslin", "La Digue",
    "Les Mamelles", "Mont Buxton", "Mont Fleuri", "Plaisance", "Pointe Larue",
    "Port Glaud", "Roche Caiman", "Saint Louis", "Takamaka"
  ],
  "Sierra Leone": [
    "Eastern", "Northern", "North Western", "Southern", "Western Area"
  ],
  "Somalia": [
    "Awdal", "Bakool", "Banaadir", "Bari", "Bay",
    "Galguduud", "Gedo", "Hiiraan", "Jubbada Dhexe", "Jubbada Hoose",
    "Mudug", "Nugaal", "Sanaag", "Shabeellaha Dhexe", "Shabeellaha Hoose",
    "Sool", "Togdheer", "Woqooyi Galbeed"
  ],
  "South Africa": [
    "Eastern Cape", "Free State", "Gauteng", "KwaZulu-Natal", "Limpopo",
    "Mpumalanga", "North West", "Northern Cape", "Western Cape"
  ],
  "South Sudan": [
    "Central Equatoria", "Eastern Equatoria", "Jonglei", "Lakes", "Northern Bahr el Ghazal",
    "Unity", "Upper Nile", "Warrap", "Western Bahr el Ghazal", "Western Equatoria"
  ],
  "Sudan": [
    "Blue Nile", "Central Darfur", "East Darfur", "Gedaref", "Gezira",
    "Kassala", "Khartoum", "North Darfur", "North Kordofan", "Northern",
    "Red Sea", "River Nile", "Sennar", "South Darfur", "South Kordofan",
    "West Darfur", "West Kordofan", "White Nile"
  ], 
  "Tanzania": [
    "Arusha", "Dar es Salaam", "Dodoma", "Geita", "Iringa",
    "Kagera", "Katavi", "Kigoma", "Kilimanjaro", "Lindi",
    "Manyara", "Mara", "Mbeya", "Morogoro", "Mtwara",
    "Mwanza", "Njombe", "Pemba North", "Pemba South", "Pwani",
    "Rukwa", "Ruvuma", "Shinyanga", "Simiyu", "Singida",
    "Songwe", "Tabora", "Tanga", "Zanzibar Central/South", "Zanzibar North",
    "Zanzibar Urban/West"
  ],
  "Togo": [
    "Centrale", "Kara", "Maritime", "Plateaux", "Savanes"
  ],
  "Tunisia": [
    "Ariana", "Béja", "Ben Arous", "Bizerte", "Gabès",
    "Gafsa", "Jendouba", "Kairouan", "Kasserine", "Kébili",
    "Kef", "Mahdia", "Manouba", "Médenine", "Monastir",
    "Nabeul", "Sfax", "Sidi Bouzid", "Siliana", "Sousse",
    "Tataouine", "Tozeur", "Tunis", "Zaghouan"
  ],
  "Uganda": [
    "Central", "Eastern", "Northern", "Western"
  ],
  "Western Sahara": [
    "Boujdour", "Es Semara", "Laâyoune", "Oued Ed-Dahab"
  ],
  "Zambia": [
    "Central", "Copperbelt", "Eastern", "Luapula", "Lusaka",
    "Muchinga", "North-Western", "Northern", "Southern", "Western"
  ],
  "Zimbabwe": [
    "Bulawayo", "Harare", "Manicaland", "Mashonaland Central", "Mashonaland East",
    "Mashonaland West", "Masvingo", "Matabeleland North", "Matabeleland South", "Midlands"
  ], 
  // South America
  "American Samoa": [
    "Eastern District", "Manu'a District", "Rose Atoll", "Swains Island", "Western District"
  ],
  "Australia": [
    "Australian Capital Territory", "New South Wales", "Northern Territory",
    "Queensland", "South Australia", "Tasmania", "Victoria", "Western Australia"
  ],
  "Cook Islands": [
    "Aitutaki", "Atiu", "Mangaia", "Manihiki", "Manuae",
    "Mauke", "Mitiaro", "Nassau", "Palmerston", "Penrhyn",
    "Pukapuka", "Rakahanga", "Rarotonga", "Suwarrow", "Takutea"
  ],
  "Fiji": [
    "Central", "Eastern", "Northern", "Rotuma", "Western"
  ],
  "French Polynesia": [
    "Îles Australes", "Îles Marquises", "Îles Sous-le-Vent",
    "Îles Tuamotu-Gambier", "Îles du Vent"
  ],
  "Guam": [
    "Agana Heights", "Agat", "Asan-Maina", "Barrigada", "Chalan Pago-Ordot",
    "Dededo", "Hagåtña", "Inarajan", "Mangilao", "Merizo",
    "Mongmong-Toto-Maite", "Piti", "Santa Rita", "Sinajana", "Talofofo",
    "Tamuning", "Umatac", "Yigo", "Yona"
  ],
  "Kiribati": [
    "Gilbert Islands", "Line Islands", "Phoenix Islands"
  ],
  "Marshall Islands": [
    "Ailinglaplap", "Ailuk", "Arno", "Aur", "Ebon",
    "Enewetak", "Jabat", "Jaluit", "Kili", "Kwajalein",
    "Lae", "Lib", "Likiep", "Majuro", "Maloelap",
    "Mejit", "Mili", "Namdrik", "Namu", "Rongelap",
    "Ujae", "Ujelang", "Utirik", "Wotho", "Wotje"
  ],
  "Micronesia": [
    "Chuuk", "Kosrae", "Pohnpei", "Yap"
  ],
  "Nauru": [
    "Aiwo", "Anabar", "Anetan", "Anibare", "Baiti",
    "Boe", "Buada", "Denigomodu", "Ewa", "Ijuw",
    "Meneng", "Nibuok", "Uaboe", "Yaren"
  ],
  "New Caledonia": [
    "Province des Îles Loyauté", "Province Nord", "Province Sud"
  ],
  "New Zealand": [
    "Auckland", "Bay of Plenty", "Canterbury", "Chatham Islands Territory",
    "Gisborne", "Hawke's Bay", "Manawatū-Whanganui", "Marlborough",
    "Nelson", "Northland", "Otago", "Southland", "Taranaki",
    "Tasman", "Waikato", "Wairarapa", "Wellington", "West Coast"
  ],
  "Niue": [
    "Alofi North", "Alofi South", "Avatele", "Hakupu", "Hikutavake",
    "Lakepa", "Liku", "Makefu", "Mutalau", "Namukulu",
    "Tamakautoga", "Toi", "Tuapa", "Vaiea"
  ],
  "Norfolk Island": [
    "Norfolk Island"
  ],
  "Northern Mariana Islands": [
    "Northern Islands", "Rota", "Saipan", "Tinian"
  ],
  "Palau": [
    "Aimeliik", "Airai", "Angaur", "Hatohobei", "Kayangel",
    "Koror", "Melekeok", "Ngaraard", "Ngarchelong", "Ngardmau",
    "Ngatpang", "Ngchesar", "Ngeremlengui", "Ngiwal", "Peleliu",
    "Sonsorol"
  ],
  "Papua New Guinea": [
    "Autonomous Region of Bougainville", "Central", "Chimbu", "Eastern Highlands",
    "East New Britain", "East Sepik", "Enga", "Gulf", "Hela",
    "Jiwaka", "Madang", "Manus", "Milne Bay", "Morobe",
    "National Capital District", "New Ireland", "Northern", "Southern Highlands",
    "Western", "Western Highlands", "West New Britain", "Sandaun"
  ],
  "Pitcairn Islands": [
    "Pitcairn Islands"
  ],
  "Samoa": [
    "A'ana", "Aiga-i-le-Tai", "Atua", "Fa'asaleleaga", "Gaga'emauga",
    "Gaga'ifomauga", "Palauli", "Satupa'itea", "Tuamasaga", "Va'a-o-Fonoti",
    "Vaisigano"
  ],
  "Solomon Islands": [
    "Central", "Choiseul", "Guadalcanal", "Honiara", "Isabel",
    "Makira-Ulawa", "Malaita", "Rennell and Bellona", "Temotu", "Western"
  ],
  "Tokelau": [
    "Atafu", "Fakaofo", "Nukunonu"
  ],
  "Tonga": [
    "'Eua", "Ha'apai", "Niuas", "Tongatapu", "Vava'u"
  ],
  "Tuvalu": [
    "Funafuti", "Nanumanga", "Nanumea", "Niutao", "Nui",
    "Nukufetau", "Nukulaelae", "Vaitupu"
  ],
  "Vanuatu": [
    "Malampa", "Penama", "Sanma", "Shefa", "Tafea",
    "Torba"
  ],
  "Wallis and Futuna": [
    "Alo", "Sigave", "Uvea"
  ], 
  // North America
  "Anguilla": [
    "Blowing Point", "East End", "George Hill", "Island Harbour", "North District",
    "North Side", "Sandy Ground", "Sandy Hill", "South Hill", "Stoney Ground",
    "The Farrington", "The Quarter", "The Valley", "West End"
  ],
  "Antigua and Barbuda": [
    "Barbuda", "Redonda", "Saint George", "Saint John", "Saint Mary",
    "Saint Paul", "Saint Peter", "Saint Philip"
  ],
  "Aruba": [
    "Noord", "Oranjestad East", "Oranjestad West", "Paradera", "San Nicolas North",
    "San Nicolas South", "Santa Cruz", "Savaneta"
  ],
  "Bahamas": [
    "Acklins", "Berry Islands", "Bimini", "Black Point", "Cat Island",
    "Central Abaco", "Central Andros", "Central Eleuthera", "City of Freeport", "Crooked Island",
    "East Grand Bahama", "Exuma", "Grand Cay", "Harbour Island", "Hope Town",
    "Inagua", "Long Island", "Mangrove Cay", "Mayaguana", "Moore's Island",
    "New Providence", "North Abaco", "North Andros", "North Eleuthera", "Ragged Island",
    "Rum Cay", "San Salvador", "South Abaco", "South Andros", "South Eleuthera",
    "Spanish Wells", "West Grand Bahama"
  ],
  "Barbados": [
    "Christ Church", "Saint Andrew", "Saint George", "Saint James", "Saint John",
    "Saint Joseph", "Saint Lucy", "Saint Michael", "Saint Peter", "Saint Philip",
    "Saint Thomas"
  ],
  "Belize": [
    "Belize", "Cayo", "Corozal", "Orange Walk", "Stann Creek",
    "Toledo"
  ],
  "Bermuda": [
    "Devonshire", "Hamilton", "Hamilton City", "Paget", "Pembroke",
    "Sandys", "Smith's", "Southampton", "St. George's", "St. George's Town", "Warwick"
  ],
  "Canada": [
    "Alberta", "British Columbia", "Manitoba", "New Brunswick", "Newfoundland and Labrador",
    "Northwest Territories", "Nova Scotia", "Nunavut", "Ontario", "Prince Edward Island",
    "Quebec", "Saskatchewan", "Yukon"
  ],
  "Caribbean Netherlands": [
    "Bonaire", "Saba", "Sint Eustatius"
  ],
  "Cayman Islands": [
    "Bodden Town", "Cayman Brac", "East End", "George Town", "Little Cayman",
    "North Side", "West Bay"
  ],
  "Costa Rica": [
    "Alajuela", "Cartago", "Guanacaste", "Heredia", "Limón",
    "Puntarenas", "San José"
  ],
  "Cuba": [
    "Artemisa", "Camagüey", "Ciego de Ávila", "Cienfuegos", "Granma",
    "Guantánamo", "Holguín", "Isla de la Juventud", "La Habana", "Las Tunas",
    "Matanzas", "Mayabeque", "Pinar del Río", "Sancti Spíritus", "Santiago de Cuba",
    "Villa Clara"
  ],
  "Curaçao": [
    "Barber", "Brievengat", "Joronis", "Lagún", "Montaña",
    "Newport", "Otrabanda", "Punda", "Soto", "Willemstad", "Bandabou", "Bandariba",
  ],
  "Dominica": [
    "Saint Andrew", "Saint David", "Saint George", "Saint John", "Saint Joseph",
    "Saint Luke", "Saint Mark", "Saint Patrick", "Saint Paul", "Saint Peter"
  ],
  "Dominican Republic": [
    "Azua", "Baoruco", "Barahona", "Dajabón", "Distrito Nacional",
    "Duarte", "El Seibo", "Elías Piña", "Espaillat", "Hato Mayor",
    "Hermanas Mirabal", "Independencia", "La Altagracia", "La Romana", "La Vega",
    "María Trinidad Sánchez", "Monseñor Nouel", "Monte Cristi", "Monte Plata", "Pedernales",
    "Peravia", "Puerto Plata", "Samaná", "San Cristóbal", "San José de Ocoa",
    "San Juan", "San Pedro de Macorís", "Sánchez Ramírez", "Santiago", "Santiago Rodríguez",
    "Santo Domingo", "Valverde"
  ],
  "El Salvador": [
    "Ahuachapán", "Cabañas", "Chalatenango", "Cuscatlán", "La Libertad",
    "La Paz", "La Unión", "Morazán", "San Miguel", "San Salvador",
    "San Vicente", "Santa Ana", "Sonsonate", "Usulután"
  ],
  "Greenland": [
    "Avannaata", "Kujalleq", "Qeqertalik", "Qeqqata", "Sermersooq"
  ],
  "Grenada": [
    "Carriacou and Petite Martinique", "Saint Andrew", "Saint David", "Saint George", "Saint John",
    "Saint Mark", "Saint Patrick"
  ],
  "Guadeloupe": [
    "Basse-Terre", "Pointe-à-Pitre"
  ],
  "Guatemala": [
    "Alta Verapaz", "Baja Verapaz", "Chimaltenango", "Chiquimula", "El Progreso",
    "Escuintla", "Guatemala", "Huehuetenango", "Izabal", "Jalapa",
    "Jutiapa", "Petén", "Quetzaltenango", "Quiché", "Retalhuleu",
    "Sacatepéquez", "San Marcos", "Santa Rosa", "Sololá", "Suchitepéquez",
    "Totonicapán", "Zacapa"
  ],
  "Haiti": [
    "Artibonite", "Centre", "Grand'Anse", "Nippes", "Nord",
    "Nord-Est", "Nord-Ouest", "Ouest", "Sud", "Sud-Est"
  ],
  "Honduras": [
    "Atlántida", "Choluteca", "Colón", "Comayagua", "Copán",
    "Cortés", "El Paraíso", "Francisco Morazán", "Gracias a Dios", "Intibucá",
    "Islas de la Bahía", "La Paz", "Lempira", "Ocotepeque", "Olancho",
    "Santa Bárbara", "Valle", "Yoro"
  ],
  "Jamaica": [
    "Clarendon", "Hanover", "Kingston", "Manchester", "Portland",
    "Saint Andrew", "Saint Ann", "Saint Catherine", "Saint Elizabeth", "Saint James",
    "Saint Mary", "Saint Thomas", "Trelawny", "Westmoreland"
  ],
  "Martinique": [
    "Fort-de-France", "La Trinité", "Le Marin", "Saint-Pierre"
  ],
  "Mexico": [
    "Aguascalientes", "Baja California", "Baja California Sur", "Campeche", "Chiapas",
    "Chihuahua", "Coahuila", "Colima", "Ciudad de México", "Durango",
    "Guanajuato", "Guerrero", "Hidalgo", "Jalisco", "México",
    "Michoacán", "Morelos", "Nayarit", "Nuevo León", "Oaxaca",
    "Puebla", "Querétaro", "Quintana Roo", "San Luis Potosí", "Sinaloa",
    "Sonora", "Tabasco", "Tamaulipas", "Tlaxcala", "Veracruz",
    "Yucatán", "Zacatecas"
  ],
  "Montserrat": [
    "Saint Anthony", "Saint Georges", "Saint Peter"
  ],
  "Netherlands Antilles": [
    "Bonaire", "Curaçao", "Saba", "Sint Eustatius", "Sint Maarten"
  ],
  "Nicaragua": [
    "Boaco", "Carazo", "Chinandega", "Chontales", "Estelí",
    "Granada", "Jinotega", "León", "Madriz", "Managua",
    "Masaya", "Matagalpa", "Nueva Segovia", "Rivas", "Río San Juan",
    "North Caribbean Coast", "South Caribbean Coast"
  ],
  "Panama": [
    "Bocas del Toro", "Chiriquí", "Coclé", "Colón", "Emberá-Wounaan",
    "Guna Yala", "Herrera", "Los Santos", "Naso Tjër Di", "Ngäbe-Buglé",
    "Panamá", "Panamá Oeste", "Veraguas"
  ],
  "Puerto Rico": [
    "Adjuntas", "Aguada", "Aguadilla", "Aguas Buenas", "Aibonito",
    "Añasco", "Arecibo", "Arroyo", "Barceloneta", "Barranquitas",
    "Bayamón", "Cabo Rojo", "Caguas", "Camuy", "Canóvanas",
    "Carolina", "Cataño", "Cayey", "Ceiba", "Ciales",
    "Cidra", "Coamo", "Comerío", "Corozal", "Culebra",
    "Dorado", "Fajardo", "Florida", "Guánica", "Guayama",
    "Guayanilla", "Guaynabo", "Gurabo", "Hatillo", "Hormigueros",
    "Humacao", "Isabela", "Jayuya", "Juana Díaz", "Juncos",
    "Lajas", "Lares", "Las Marías", "Las Piedras", "Loíza",
    "Luquillo", "Manatí", "Maricao", "Maunabo", "Mayagüez",
    "Moca", "Morovis", "Naguabo", "Naranjito", "Orocovis",
    "Patillas", "Peñuelas", "Ponce", "Quebradillas", "Rincón",
    "Río Grande", "Sabana Grande", "Salinas", "San Germán", "San Juan",
    "San Lorenzo", "San Sebastián", "Santa Isabel", "Toa Alta", "Toa Baja",
    "Trujillo Alto", "Utuado", "Vega Alta", "Vega Baja", "Vieques",
    "Villalba", "Yabucoa", "Yauco"
  ],
  "Saint Barthelemy": [
    "Au Vent", "Sous le Vent"
  ],
  "Saint Kitts and Nevis": [
    "Christ Church Nichola Town", "Saint Anne Sandy Point", "Saint George Basseterre", "Saint George Gingerland", "Saint James Windward",
    "Saint John Capesterre", "Saint John Figtree", "Saint Mary Cayon", "Saint Paul Capesterre", "Saint Paul Charlestown",
    "Saint Peter Basseterre", "Saint Thomas Lowland", "Saint Thomas Middle Island", "Trinity Palmetto Point"
  ],
  "Saint Lucia": [
    "Anse la Raye", "Canaries", "Castries", "Choiseul", "Dennery",
    "Gros Islet", "Laborie", "Micoud", "Soufrière", "Vieux Fort"
  ],
  "Saint Martin": [
    "Saint Martin"
  ],
  "Saint Pierre and Miquelon": [
    "Miquelon-Langlade", "Saint-Pierre"
  ],
  "Saint Vincent and the Grenadines": [
    "Charlotte", "Grenadines", "Saint Andrew", "Saint David", "Saint George",
    "Saint Patrick"
  ],
  "Sint Maarten": [
    "Sint Maarten"
  ],
  "Trinidad and Tobago": [
    "Arima", "Chaguanas", "Couva-Tabaquite-Talparo", "Diego Martin", "Mayaro-Rio Claro",
    "Penal-Debe", "Point Fortin", "Port of Spain", "Princes Town", "San Fernando",
    "Sangre Grande", "San Juan-Laventille", "Siparia", "Tobago", "Tunapuna-Piarco"
  ],
  "Turks and Caicos Islands": [
    "Grand Turk", "Middle Caicos", "North Caicos", "Providenciales", "South Caicos",
    "West Caicos"
  ],
  "U.S. Outlying Islands": [
    "Baker Island", "Howland Island", "Jarvis Island", "Johnston Atoll", "Kingman Reef",
    "Midway Atoll", "Navassa Island", "Palmyra Atoll", "Wake Island"
  ], 
  "United States": [
    "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware",
    "District of Columbia", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas",
    "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi",
    "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York",
    "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island",
    "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington",
    "West Virginia", "Wisconsin", "Wyoming"
  ],
  "Virgin Islands, British": [
    "Anegada", "Jost Van Dyke", "Tortola", "Virgin Gorda"
  ], 
  // 
  "Antarctica": [
    "Adélie Land", "Argentine Antarctica", "Australian Antarctic Territory",
    "Chilean Antarctic Territory", "Peter I Island", "Queen Maud Land", "Ross Dependency"
  ],
  "Bouvet Island": [
    "Bouvet Island"
  ],
  "French Southern Territories": [
    "Îles Éparses", "Îles Kerguelen", "Île Saint-Paul et Île Amsterdam", "Crozet Islands"
  ],
  "Heard Island and Mcdonald Islands": [
    "Heard Island", "McDonald Islands"
  ],
  "South Georgia and the South Sandwich Islands": [
    "South Georgia", "South Sandwich Islands"
  ], 
  "Argentina": [
    "Buenos Aires", "Catamarca", "Chaco", "Chubut", "Ciudad Autónoma de Buenos Aires",
    "Córdoba", "Corrientes", "Entre Ríos", "Formosa", "Jujuy",
    "La Pampa", "La Rioja", "Mendoza", "Misiones", "Neuquén",
    "Río Negro", "Salta", "San Juan", "San Luis", "Santa Cruz",
    "Santa Fe", "Santiago del Estero", "Tierra del Fuego", "Tucumán"
  ],
  "Bolivia (Plurinational State of)": [
    "Beni", "Chuquisaca", "Cochabamba", "La Paz", "Oruro",
    "Pando", "Potosí", "Santa Cruz", "Tarija"
  ],
  "Brazil": [
    "Acre", "Alagoas", "Amapá", "Amazonas", "Bahia",
    "Ceará", "Distrito Federal", "Espírito Santo", "Goiás", "Maranhão",
    "Mato Grosso", "Mato Grosso do Sul", "Minas Gerais", "Pará", "Paraíba",
    "Paraná", "Pernambuco", "Piauí", "Rio de Janeiro", "Rio Grande do Norte",
    "Rio Grande do Sul", "Rondônia", "Roraima", "Santa Catarina", "São Paulo",
    "Sergipe", "Tocantins"
  ], 
  "Chile": [
    "Aisén", "Antofagasta", "Araucanía", "Arica y Parinacota", "Atacama",
    "Bío-Bío", "Coquimbo", "La Araucanía", "Los Lagos", "Los Ríos",
    "Magallanes y de la Antártica Chilena", "Maule", "Ñuble", "O'Higgins",
    "Región Metropolitana de Santiago", "Tarapacá", "Valparaíso"
  ],
  "Colombia": [
    "Amazonas", "Antioquia", "Arauca", "Atlántico", "Bogotá, D.C.",
    "Bolívar", "Boyacá", "Caldas", "Caquetá", "Casanare",
    "Cauca", "Cesar", "Chocó", "Córdoba", "Cundinamarca",
    "Guainía", "Guaviare", "Huila", "La Guajira", "Magdalena",
    "Meta", "Nariño", "Norte de Santander", "Putumayo", "Quindío",
    "Risaralda", "San Andrés, Providencia y Santa Catalina", "Santander", "Sucre", "Tolima",
    "Valle del Cauca", "Vaupés", "Vichada"
  ],
  "Ecuador": [
    "Azuay", "Bolívar", "Cañar", "Carchi", "Chimborazo",
    "Cotopaxi", "El Oro", "Esmeraldas", "Galápagos", "Guayas",
    "Imbabura", "Loja", "Los Ríos", "Manabí", "Morona Santiago",
    "Napo", "Orellana", "Pastaza", "Pichincha", "Santa Elena",
    "Santo Domingo de los Tsáchilas", "Sucumbíos", "Tungurahua", "Zamora Chinchipe"
  ], 
  "Falkland Islands (Malvinas)": [
    "East Falkland", "West Falkland"
  ],
  "French Guiana": [
    "Cayenne", "Saint-Laurent-du-Maroni"
  ],
  "Guyana": [
    "Barima-Waini", "Cuyuni-Mazaruni", "Demerara-Mahaica",
    "East Berbice-Corentyne", "Essequibo Islands-West Demerara",
    "Mahaica-Berbice", "Pomeroon-Supenaam", "Potaro-Siparuni",
    "Upper Demerara-Berbice", "Upper Takutu-Upper Essequibo"
  ], 
  "Paraguay": [
    "Alto Paraguay", "Alto Paraná", "Amambay", "Asunción", "Boquerón",
    "Caaguazú", "Caazapá", "Canindeyú", "Central", "Concepción",
    "Cordillera", "Guairá", "Itapúa", "Misiones", "Ñeembucú",
    "Paraguarí", "Presidente Hayes", "San Pedro"
  ],
  "Peru": [
    "Amazonas", "Ancash", "Apurímac", "Arequipa", "Ayacucho",
    "Cajamarca", "Callao", "Cusco", "Huancavelica", "Huánuco",
    "Ica", "Junín", "La Libertad", "Lambayeque", "Lima",
    "Lima Metropolitan", "Loreto", "Madre de Dios", "Moquegua", "Pasco",
    "Piura", "Puno", "San Martín", "Tacna", "Tumbes",
    "Ucayali"
  ],
  "Suriname": [
    "Brokopondo", "Commewijne", "Coronie", "Marowijne", "Nickerie",
    "Para", "Paramaribo", "Saramacca", "Sipaliwini", "Wanica"
  ],
  "Uruguay": [
    "Artigas", "Canelones", "Cerro Largo", "Colonia", "Durazno",
    "Flores", "Florida", "Lavalleja", "Maldonado", "Montevideo",
    "Paysandú", "Río Negro", "Rivera", "Rocha", "Salto",
    "San José", "Soriano", "Tacuarembó", "Treinta y Tres"
  ],
  "Venezuela": [
    "Amazonas", "Anzoátegui", "Apure", "Aragua", "Barinas",
    "Bolívar", "Carabobo", "Cojedes", "Delta Amacuro", "Dependencias Federales",
    "Distrito Capital", "Falcón", "Guárico", "Lara", "Mérida",
    "Miranda", "Monagas", "Nueva Esparta", "Portuguesa", "Sucre",
    "Táchira", "Trujillo", "Vargas", "Yaracuy", "Zulia"
  ], 
};

class RegisterNewComplaint extends Component {
  constructor(props) {
    super(props);
    this.jobListRef = React.createRef();
    this.state = { 
      error: false,
      was_validated: false,
      captcha_validated: false,
      product_count: 1,

      CompanyName: "",
      address: "",
      country: "",
      stateProvince: "",
      contactPersonFirstName: "",
      contactPersonLastName: "",
      contactPersonMobileNumber: "",
      contactPersonEmailId: "",
      purchaseManagerSameAsAbove: false,
      purchaseManagerFirstName: "",
      purchaseManagerLastName: "",
      purchaseManagerMobileNumber: "",
      purchaseManagerEmailId: "",
      
      jobNumber1: "",
      serialNumber1: "",
      nameOfEquipment1: "",
      natureOfProblem1: "",
      comments1: "",
      attachments1: "",

      jobNumber2: "",
      serialNumber2: "",
      nameOfEquipment2: "",
      natureOfProblem2: "",
      comments2: "",
      attachments2: "",

      jobNumber3: "",
      serialNumber3: "",
      nameOfEquipment3: "",
      natureOfProblem3: "",
      comments3: "",
      attachments3: "",

      jobNumber4: "",
      serialNumber4: "",
      nameOfEquipment4: "",
      natureOfProblem4: "",
      comments4: "",
      attachments4: "",

      jobNumber5: "",
      serialNumber5: "",
      nameOfEquipment5: "",
      natureOfProblem5: "",
      comments5: "",
      attachments5: "",

      jobNumber6: "",
      serialNumber6: "",
      nameOfEquipment6: "",
      natureOfProblem6: "",
      comments6: "",
      attachments6: "",

      jobNumber7: "",
      serialNumber7: "",
      nameOfEquipment7: "",
      natureOfProblem7: "",
      comments7: "",
      attachments7: "",

      jobNumber8: "",
      serialNumber8: "",
      nameOfEquipment8: "",
      natureOfProblem8: "",
      comments8: "",
      attachments8: "",

      jobNumber9: "",
      serialNumber9: "",
      nameOfEquipment9: "",
      natureOfProblem9: "",
      comments9: "",
      attachments9: "",

      jobNumber10: "",
      serialNumber10: "",
      nameOfEquipment10: "",
      natureOfProblem10: "",
      comments10: "",
      attachments10: "",

      jobNumber11: "",
      serialNumber11: "",
      nameOfEquipment11: "",
      natureOfProblem11: "",
      comments11: "",
      attachments11: "",

      jobNumber12: "",
      serialNumber12: "",
      nameOfEquipment12: "",
      natureOfProblem12: "",
      comments12: "",
      attachments12: "",

      jobNumber13: "",
      serialNumber13: "",
      nameOfEquipment13: "",
      natureOfProblem13: "",
      comments13: "",
      attachments13: "",

      jobNumber14: "",
      serialNumber14: "",
      nameOfEquipment14: "",
      natureOfProblem14: "",
      comments14: "",
      attachments14: "",

      jobNumber15: "",
      serialNumber15: "",
      nameOfEquipment15: "",
      natureOfProblem15: "",
      comments15: "",
      attachments15: "",

      jobNumber16: "",
      serialNumber16: "",
      nameOfEquipment16: "",
      natureOfProblem16: "",
      comments16: "",
      attachments16: "",

      jobNumber17: "",
      serialNumber17: "",
      nameOfEquipment17: "",
      natureOfProblem17: "",
      comments17: "",
      attachments17: "",

      jobNumber18: "",
      serialNumber18: "",
      nameOfEquipment18: "",
      natureOfProblem18: "",
      comments18: "",
      attachments18: "",

      jobNumber19: "",
      serialNumber19: "",
      nameOfEquipment19: "",
      natureOfProblem19: "",
      comments19: "",
      attachments19: "",

      jobNumber20: "",
      serialNumber20: "",
      nameOfEquipment20: "",
      natureOfProblem20: "",
      comments20: "",
      attachments20: "",
    };
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    if(this.state.error) {
      return common.redirectToError();
    } else {
        return (
          <div class="container2 m-0">
            <main>
              <div class="py-5 text-center">
                <img class="d-block mx-auto mb-4" src="./scrlogo.png" alt="" width="72" height="72" />
                <h2>Register new complaint</h2>
                <p class="lead">Need support ? Don't Worry, our world wide customer support is few clicks away.</p>
              </div>

              <div class="row g-5 justify-content-center">
                <div class="col-md-9 col-lg-9">
                  <form novalidate onSubmit={this.saveNewComplaint} class={`${this.state.was_validated ? "was-validated" : "needs-validation"}`} >
                    <div class="row g-3">
                      <h4 class="mb-3">Your Details</h4>
                      
                      <div class="col-12">
                        <label for="CompanyName" class="form-label">Name of Company</label>
                        <input type="text" class="form-control" id="CompanyName" placeholder="Your Company name e.g. SCR ELEKTRONIKS PRIVATE LIMITED" value={this.state.CompanyName} onChange={this.CompanyNameValueChange} required />
                        <div class="invalid-feedback">
                          Please enter your Company Name.
                        </div>
                      </div>
                      
                      <div class="col-12">
                        <label for="address" class="form-label">Address</label>
                        <input type="text" class="form-control" id="address" placeholder="e.g. W-188, MIDC, Dombivli, Maharashtra - 421204" value={this.state.address} onChange={this.addressValueChange} required />
                        <div class="invalid-feedback">
                          Please enter your company address.
                        </div>
                      </div>

                      <div class="col-md-6">
                        <label for="country" class="form-label">Country</label>
                        <select class="form-select" id="country" value={this.state.country} onChange={this.countryValueChange} required>
                          <option value="">Choose...</option>
                          <option value="India">India</option>
                          <optgroup label="Asia">
                            <option value="Afghanistan">Afghanistan</option>
                            <option value="Armenia">Armenia</option>
                            <option value="Azerbaijan">Azerbaijan</option>
                            <option value="Bahrain">Bahrain</option>
                            <option value="Bangladesh">Bangladesh</option>
                            <option value="Bhutan">Bhutan</option>
                            <option value="British Indian Ocean Territory">British Indian Ocean Territory</option>
                            <option value="Brunei Darussalam">Brunei Darussalam</option>
                            <option value="Cambodia">Cambodia</option>
                            <option value="China">China</option>
                            <option value="Christmas Island">Christmas Island</option>
                            <option value="Cocos (Keeling) Islands">Cocos (Keeling) Islands</option>
                            <option value="Cyprus">Cyprus</option>
                            <option value="Georgia">Georgia</option>
                            <option value="Hong Kong">Hong Kong</option>
                            <option value="India">India</option>
                            <option value="Indonesia">Indonesia</option>
                            <option value="Iran">Iran</option>
                            <option value="Iraq">Iraq</option>
                            <option value="Israel">Israel</option>
                            <option value="Japan">Japan</option>
                            <option value="Jordan">Jordan</option>
                            <option value="Kazakhstan">Kazakhstan</option>
                            <option value="Korea, North">Korea, North</option>
                            <option value="Korea, South">Korea, South</option>
                            <option value="Kuwait">Kuwait</option>
                            <option value="Kyrgyzstan">Kyrgyzstan</option>
                            <option value="Lao People's Democratic Republic">Lao People's Democratic Republic</option>
                            <option value="Lebanon">Lebanon</option>
                            <option value="Macao">Macao</option>
                            <option value="Malaysia">Malaysia</option>
                            <option value="Maldives">Maldives</option>
                            <option value="Mongolia">Mongolia</option>
                            <option value="Myanmar (Burma)">Myanmar (Burma)</option>
                            <option value="Nepal">Nepal</option>
                            <option value="Oman">Oman</option>
                            <option value="Pakistan">Pakistan</option>
                            <option value="Palestine">Palestine</option>
                            <option value="Philippines">Philippines</option>
                            <option value="Qatar">Qatar</option>
                            <option value="Russian Federation">Russian Federation</option>
                            <option value="Saudi Arabia">Saudi Arabia</option>
                            <option value="Singapore">Singapore</option>
                            <option value="Sri Lanka">Sri Lanka</option>
                            <option value="Syria">Syria</option>
                            <option value="Taiwan">Taiwan</option>
                            <option value="Tajikistan">Tajikistan</option>
                            <option value="Thailand">Thailand</option>
                            <option value="Timor-Leste">Timor-Leste</option>
                            <option value="Turkey (Türkiye)">Turkey (Türkiye)</option>
                            <option value="Turkmenistan">Turkmenistan</option>
                            <option value="United Arab Emirates">United Arab Emirates</option>
                            <option value="Uzbekistan">Uzbekistan</option>
                            <option value="Vietnam">Vietnam</option>
                            <option value="Yemen">Yemen</option>
                        </optgroup>
                        <optgroup label="Europe">
                            <option value="Åland Islands">Åland Islands</option>
                            <option value="Albania">Albania</option>
                            <option value="Andorra">Andorra</option>
                            <option value="Austria">Austria</option>
                            <option value="Belarus">Belarus</option>
                            <option value="Belgium">Belgium</option>
                            <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                            <option value="Bulgaria">Bulgaria</option>
                            <option value="Croatia">Croatia</option>
                            <option value="Czech Republic">Czech Republic</option>
                            <option value="Denmark">Denmark</option>
                            <option value="Estonia">Estonia</option>
                            <option value="Faroe Islands">Faroe Islands</option>
                            <option value="Finland">Finland</option>
                            <option value="France">France</option>
                            <option value="Germany">Germany</option>
                            <option value="Gibraltar">Gibraltar</option>
                            <option value="Greece">Greece</option>
                            <option value="Guernsey">Guernsey</option>
                            <option value="Hungary">Hungary</option>
                            <option value="Iceland">Iceland</option>
                            <option value="Ireland">Ireland</option>
                            <option value="Isle of Man">Isle of Man</option>
                            <option value="Italy">Italy</option>
                            <option value="Jersey">Jersey</option>
                            <option value="Kosovo">Kosovo</option>
                            <option value="Latvia">Latvia</option>
                            <option value="Liechtenstein">Liechtenstein</option>
                            <option value="Lithuania">Lithuania</option>
                            <option value="Luxembourg">Luxembourg</option>
                            <option value="Macedonia North">Macedonia North</option>
                            <option value="Malta">Malta</option>
                            <option value="Moldova">Moldova</option>
                            <option value="Monaco">Monaco</option>
                            <option value="Montenegro">Montenegro</option>
                            <option value="Netherlands">Netherlands</option>
                            <option value="Norway">Norway</option>
                            <option value="Poland">Poland</option>
                            <option value="Portugal">Portugal</option>
                            <option value="Romania">Romania</option>
                            <option value="San Marino">San Marino</option>
                            <option value="Serbia">Serbia</option>
                            <option value="Serbia and Montenegro">Serbia and Montenegro</option>
                            <option value="Slovakia">Slovakia</option>
                            <option value="Slovenia">Slovenia</option>
                            <option value="Spain">Spain</option>
                            <option value="Svalbard and Jan Mayen">Svalbard and Jan Mayen</option>
                            <option value="Sweden">Sweden</option>
                            <option value="Switzerland">Switzerland</option>
                            <option value="Ukraine">Ukraine</option>
                            <option value="United Kingdom">United Kingdom</option>
                            <option value="Vatican City Holy See">Vatican City Holy See</option>
                        </optgroup>
                        <optgroup label="Africa">
                            <option value="Algeria">Algeria</option>
                            <option value="Angola">Angola</option>
                            <option value="Benin">Benin</option>
                            <option value="Botswana">Botswana</option>
                            <option value="Burkina Faso">Burkina Faso</option>
                            <option value="Burundi">Burundi</option>
                            <option value="Cabo Verde">Cabo Verde</option>
                            <option value="Cameroon">Cameroon</option>
                            <option value="Central African Republic">Central African Republic</option>
                            <option value="Chad">Chad</option>
                            <option value="Comoros">Comoros</option>
                            <option value="Congo">Congo</option>
                            <option value="Congo, Democratic Republic of the">Congo, Democratic Republic of the</option>
                            <option value="Côte d'Ivoire">Côte d'Ivoire</option>
                            <option value="Djibouti">Djibouti</option>
                            <option value="Egypt">Egypt</option>
                            <option value="Equatorial Guinea">Equatorial Guinea</option>
                            <option value="Eritrea">Eritrea</option>
                            <option value="Eswatini (Swaziland)">Eswatini (Swaziland)</option>
                            <option value="Ethiopia">Ethiopia</option>
                            <option value="Gabon">Gabon</option>
                            <option value="Gambia">Gambia</option>
                            <option value="Ghana">Ghana</option>
                            <option value="Guinea">Guinea</option>
                            <option value="Guinea-Bissau">Guinea-Bissau</option>
                            <option value="Kenya">Kenya</option>
                            <option value="Lesotho">Lesotho</option>
                            <option value="Liberia">Liberia</option>
                            <option value="Libya">Libya</option>
                            <option value="Madagascar">Madagascar</option>
                            <option value="Malawi">Malawi</option>
                            <option value="Mali">Mali</option>
                            <option value="Mauritania">Mauritania</option>
                            <option value="Mauritius">Mauritius</option>
                            <option value="Mayotte">Mayotte</option>
                            <option value="Morocco">Morocco</option>
                            <option value="Mozambique">Mozambique</option>
                            <option value="Namibia">Namibia</option>
                            <option value="Niger">Niger</option>
                            <option value="Nigeria">Nigeria</option>
                            <option value="Reunion">Reunion</option>
                            <option value="Rwanda">Rwanda</option>
                            <option value="Saint Helena">Saint Helena</option>
                            <option value="Sao Tome and Principe">Sao Tome and Principe</option>
                            <option value="Senegal">Senegal</option>
                            <option value="Seychelles">Seychelles</option>
                            <option value="Sierra Leone">Sierra Leone</option>
                            <option value="Somalia">Somalia</option>
                            <option value="South Africa">South Africa</option>
                            <option value="South Sudan">South Sudan</option>
                            <option value="Sudan">Sudan</option>
                            <option value="Tanzania">Tanzania</option>
                            <option value="Togo">Togo</option>
                            <option value="Tunisia">Tunisia</option>
                            <option value="Uganda">Uganda</option>
                            <option value="Western Sahara">Western Sahara</option>
                            <option value="Zambia">Zambia</option>
                            <option value="Zimbabwe">Zimbabwe</option>
                        </optgroup>
                        <optgroup label="Australia (Oceania)">
                            <option value="American Samoa">American Samoa</option>
                            <option value="Australia">Australia</option>
                            <option value="Cook Islands">Cook Islands</option>
                            <option value="Fiji">Fiji</option>
                            <option value="French Polynesia">French Polynesia</option>
                            <option value="Guam">Guam</option>
                            <option value="Kiribati">Kiribati</option>
                            <option value="Marshall Islands">Marshall Islands</option>
                            <option value="Micronesia">Micronesia</option>
                            <option value="Nauru">Nauru</option>
                            <option value="New Caledonia">New Caledonia</option>
                            <option value="New Zealand">New Zealand</option>
                            <option value="Niue">Niue</option>
                            <option value="Norfolk Island">Norfolk Island</option>
                            <option value="Northern Mariana Islands">Northern Mariana Islands</option>
                            <option value="Palau">Palau</option>
                            <option value="Papua New Guinea">Papua New Guinea</option>
                            <option value="Pitcairn Islands">Pitcairn Islands</option>
                            <option value="Samoa">Samoa</option>
                            <option value="Solomon Islands">Solomon Islands</option>
                            <option value="Tokelau">Tokelau</option>
                            <option value="Tonga">Tonga</option>
                            <option value="Tuvalu">Tuvalu</option>
                            <option value="Vanuatu">Vanuatu</option>
                            <option value="Wallis and Futuna">Wallis and Futuna</option>
                        </optgroup>
                        <optgroup label="North America">
                            <option value="Anguilla">Anguilla</option>
                            <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                            <option value="Aruba">Aruba</option>
                            <option value="Bahamas">Bahamas</option>
                            <option value="Barbados">Barbados</option>
                            <option value="Belize">Belize</option>
                            <option value="Bermuda">Bermuda</option>
                            <option value="Canada">Canada</option>
                            <option value="Caribbean Netherlands">Caribbean Netherlands</option>
                            <option value="Cayman Islands">Cayman Islands</option>
                            <option value="Costa Rica">Costa Rica</option>
                            <option value="Cuba">Cuba</option>
                            <option value="Curaçao">Curaçao</option>
                            <option value="Dominica">Dominica</option>
                            <option value="Dominican Republic">Dominican Republic</option>
                            <option value="El Salvador">El Salvador</option>
                            <option value="Greenland">Greenland</option>
                            <option value="Grenada">Grenada</option>
                            <option value="Guadeloupe">Guadeloupe</option>
                            <option value="Guatemala">Guatemala</option>
                            <option value="Haiti">Haiti</option>
                            <option value="Honduras">Honduras</option>
                            <option value="Jamaica">Jamaica</option>
                            <option value="Martinique">Martinique</option>
                            <option value="Mexico">Mexico</option>
                            <option value="Montserrat">Montserrat</option>
                            <option value="Netherlands Antilles">Netherlands Antilles</option>
                            <option value="Nicaragua">Nicaragua</option>
                            <option value="Panama">Panama</option>
                            <option value="Puerto Rico">Puerto Rico</option>
                            <option value="Saint Barthelemy">Saint Barthelemy</option>
                            <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
                            <option value="Saint Lucia">Saint Lucia</option>
                            <option value="Saint Martin">Saint Martin</option>
                            <option value="Saint Pierre and Miquelon">Saint Pierre and Miquelon</option>
                            <option value="Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
                            <option value="Sint Maarten">Sint Maarten</option>
                            <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                            <option value="Turks and Caicos Islands">Turks and Caicos Islands</option>
                            <option value="U.S. Outlying Islands">U.S. Outlying Islands</option>
                            <option value="United States">United States</option>
                            <option value="Virgin Islands, British">Virgin Islands, British</option>
                            <option value="Virgin Islands, U.S">Virgin Islands, U.S</option>
                        </optgroup>
                        <optgroup label="Antarctica">
                            <option value="Antarctica">Antarctica</option>
                            <option value="Bouvet Island">Bouvet Island</option>
                            <option value="French Southern Territories">French Southern Territories</option>
                            <option value="Heard Island and Mcdonald Islands">Heard Island and Mcdonald Islands</option>
                            <option value="South Georgia and the South Sandwich Islands">South Georgia and the South Sandwich Islands</option>
                        </optgroup>
                        <optgroup label="South America">
                            <option value="Argentina">Argentina</option>
                            <option value="Bolivia (Plurinational State of)">Bolivia (Plurinational State of)</option>
                            <option value="Brazil">Brazil</option>
                            <option value="Chile">Chile</option>
                            <option value="Colombia">Colombia</option>
                            <option value="Ecuador">Ecuador</option>
                            <option value="Falkland Islands (Malvinas)">Falkland Islands (Malvinas)</option>
                            <option value="French Guiana">French Guiana</option>
                            <option value="Guyana">Guyana</option>
                            <option value="Paraguay">Paraguay</option>
                            <option value="Peru">Peru</option>
                            <option value="Suriname">Suriname</option>
                            <option value="Uruguay">Uruguay</option>
                            <option value="Venezuela">Venezuela</option>
                        </optgroup>
                        </select>
                        <div class="invalid-feedback">
                          Please select a valid country.
                        </div>
                      </div>

                      <div class="col-md-6">
                        <label for="stateProvince" class="form-label">State / Province</label>
                        {STATES_BY_COUNTRY[this.state.country] ? (
                          <select class="form-select" id="stateProvince" value={this.state.stateProvince} onChange={this.stateProvinceValueChange} required>
                            <option value="">Choose...</option>
                            {STATES_BY_COUNTRY[this.state.country].map((st) => (
                              <option key={st} value={st}>{st}</option>
                            ))}
                          </select>
                        ) : (
                          <input type="text" class="form-control" id="stateProvince" placeholder={this.state.country ? "State / Province / Region" : "Select a country first"} value={this.state.stateProvince} onChange={this.stateProvinceValueChange} disabled={!this.state.country} />
                        )}
                        <div class="invalid-feedback">
                          Please select a valid state.
                        </div>
                      </div>

                      <div class="col-12 mt-0 mb-0">
                        <hr class="my-4 mb-0" />
                      </div>

                      <span class="text-muted">Contact Person</span>

                      <div class="col-sm-6">
                        <label for="contactPersonFirstName" class="form-label">First name <span class="text-muted"></span></label>
                        <input type="text" class="form-control" id="contactPersonFirstName" placeholder="First Name" value={this.state.contactPersonFirstName} onChange={this.contactPersonFirstNameValueChange} required />
                        <div class="invalid-feedback">
                          Valid first name of Contact Person is required.
                        </div>
                      </div>

                      <div class="col-sm-6">
                        <label for="contactPersonLastName" class="form-label">Last name <span class="text-muted"></span></label>
                        <input type="text" class="form-control" id="contactPersonLastName" placeholder="Last Name" value={this.state.contactPersonLastName} onChange={this.contactPersonLastNameValueChange} required />
                        <div class="invalid-feedback">
                          Valid last name of Contact Person is required.
                        </div>
                      </div>

                      <div class="col-12">
                        <label for="contactPersonPhone" class="form-label">Mobile Number</label>
                        <input type="tel" class="form-control" id="contactPersonPhone" placeholder="e.g. +91 9821619863" value={this.state.contactPersonMobileNumber} onChange={this.contactPersonMobileNumberValueChange} required />
                        <div class="invalid-feedback">
                          Please enter a valid mobile number of Contact Person to whome we may contact for more details about the problem.
                        </div>
                      </div>

                      <div class="col-12">
                        <label for="contactPersonEmail" class="form-label">Email</label>
                        <input type="email" class="form-control" id="contactPersonEmail" placeholder="e.g. you@example.com" value={this.state.contactPersonEmailId} onChange={this.contactPersonEmailIdValueChange} required />
                        <div class="invalid-feedback">
                          Please enter a valid email address of Contact Person.
                        </div>
                      </div>

                      <div class="col-12 mt-0 mb-0">
                        <hr class="my-4 mb-0" />
                      </div>

                      <span class="text-muted">Purchase Manager&nbsp;&nbsp;&nbsp;
                        <span class="text-muted">(&nbsp;</span>
                        <input class="form-check-input" type="checkbox" value="" id="purchaseManagerSameAsAbove" onChange={this.purchaseManagerSameAsAboveEvent}/>
                        <span class="text-muted">&nbsp;same as above)</span>
                      </span> 
                      
                      <div class="col-sm-6">
                        <label for="purchaseManagerFirstName" class="form-label">First name <span class="text-muted"></span></label>
                        <input type="text" class="form-control" id="purchaseManagerFirstName" placeholder="First Name" value={this.state.purchaseManagerFirstName} onChange={this.purchaseManagerFirstNameValueChange} disabled={this.state.purchaseManagerSameAsAbove ? true : false} required />
                        <div class="invalid-feedback">
                          Valid first name of your Purchase Manager is required.
                        </div>
                      </div>

                      <div class="col-sm-6">
                        <label for="purchaseManagerLastName" class="form-label">Last name <span class="text-muted"></span></label>
                        <input type="text" class="form-control" id="purchaseManagerLastName" placeholder="Last Name" value={this.state.purchaseManagerLastName} onChange={this.purchaseManagerLastNameValueChange} disabled={this.state.purchaseManagerSameAsAbove ? true : false} required />
                        <div class="invalid-feedback">
                          Valid last name of your Purchase Manager is required.
                        </div>
                      </div>

                      <div class="col-12">
                        <label for="purchaseManagerPhone" class="form-label">Mobile Number</label>
                        <input type="tel" class="form-control" id="purchaseManagerPhone" placeholder="e.g. +91 9821619863" value={this.state.purchaseManagerMobileNumber} onChange={this.purchaseManagerMobileNumberValueChange} disabled={this.state.purchaseManagerSameAsAbove ? true : false} required />
                        <div class="invalid-feedback">
                          Please enter a valid mobile number of your Purchase Manager.
                        </div>
                      </div>

                      <div class="col-12">
                        <label for="purchaseManagerEmail" class="form-label">Email</label>
                        <input type="email" class="form-control" id="purchaseManagerEmail" placeholder="e.g. you@example.com" value={this.state.purchaseManagerEmailId} onChange={this.purchaseManagerEmailIdValueChange} disabled={this.state.purchaseManagerSameAsAbove ? true : false} required />
                        <div class="invalid-feedback">
                          Please enter a valid email address of Purchase Manager.
                        </div>
                      </div>

                      <div class="col-12 mt-0 mb-0">
                        <hr class="my-4 mb-0" />
                      </div>

                      <div  class="row g-3 ms-0 me-0 p-0">
                        <div class="col-12">
                          <h4 class="mt-3 mb-3">Product Details</h4>
                        </div>

                        <div class="col-12">
                          <label for="jobNumber1" class="form-label">Job Number<span class="text-muted"> (Located below Mains ON/OFF MCB)</span></label>
                          <input type="text" class="form-control" id="jobNumber1" placeholder="2526-JS001" value={this.state.jobNumber1} onChange={this.jobNumber1ChangeEvent} required />
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="serialNumber1" class="form-label">Serial Number<span class="text-muted"> (Located at back side of panel near input supply)</span></label>
                          <input type="text" class="form-control" id="serialNumber1" placeholder="2502001" value={this.state.serialNumber1} onChange={this.serialNumber1ChangeEvent} required />
                          <div class="invalid-feedback">
                            Please enter the Serial Number of equipment. It is located at back side of panel near input supply.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="nameOfEquipment1" class="form-label">Name of equipment</label>
                          <input type="text" class="form-control" id="nameOfEquipment1" placeholder="Glow Wire Test Apparatus" value={this.state.nameOfEquipment1} onChange={this.nameOfEquipment1ChangeEvent} required />
                          <div class="invalid-feedback">
                            Please enter the Name of equipment.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="natureOfProblem1" class="form-label">Nature of Problem</label>
                          <textarea class="form-control" id="natureOfProblem1" placeholder="Please describe the problem faced in Panel" rows="4" value={this.state.natureOfProblem1} onChange={this.natureOfProblem1ChangeEvent} required></textarea>
                          <div class="invalid-feedback">
                            Please enter Nature of Problem.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="comments1" class="form-label">Comments<span class="text-muted"> (Optional)</span></label>
                          <textarea class="form-control" id="comments1" placeholder="Feel free to leave any additional comments here" rows="4" value={this.state.comments1} onChange={this.comments1ChangeEvent}></textarea>
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="attachments1" class="form-label">Attachments<span class="text-muted"> (Optional)</span></label>
                          <input class="form-control" type="file" id="attachments1" value={this.state.attachments1} onChange={this.attachments1ChangeEvent} multiple />
                        </div>

                        <div class="col-12">
                          <hr class="my-4 mb-0" />
                        </div>
                      </div>

                      <div class={`${this.state.product_count >= 2 ? 'row g-3 ms-0 me-0 p-0 collapse show' : 'collapse'}`} >
                        <div class="col-12">
                          <h4 class="mt-3 mb-3">Product Details (2)</h4>
                        </div>

                        <div class="col-12">
                          <label for="jobNumber2" class="form-label">Job Number<span class="text-muted"> (Located below Mains ON/OFF MCB)</span></label>
                          <input type="text" class="form-control" id="jobNumber2" placeholder="2526-JS001" value={this.state.jobNumber2} onChange={this.jobNumber2ChangeEvent} required={this.state.product_count>=2} />
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="serialNumber2" class="form-label">Serial Number<span class="text-muted"> (Located at back side of panel near input supply)</span></label>
                          <input type="text" class="form-control" id="serialNumber2" placeholder="2502001" value={this.state.serialNumber2} onChange={this.serialNumber2ChangeEvent} required={this.state.product_count>=2} />
                          <div class="invalid-feedback">
                            Please enter the Serial Number of equipment. It is located at back side of panel near input supply.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="nameOfEquipment2" class="form-label">Name of equipment</label>
                          <input type="text" class="form-control" id="nameOfEquipment2" placeholder="Glow Wire Test Apparatus" value={this.state.nameOfEquipment2} onChange={this.nameOfEquipment2ChangeEvent} required={this.state.product_count>=2} />
                          <div class="invalid-feedback">
                            Please enter the Name of equipment.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="natureOfProblem2" class="form-label">Nature of Problem</label>
                          <textarea class="form-control" id="natureOfProblem2" placeholder="Please describe the problem faced in Panel" rows="4" value={this.state.natureOfProblem2} onChange={this.natureOfProblem2ChangeEvent} required={this.state.product_count>=2} ></textarea>
                          <div class="invalid-feedback">
                            Please enter Nature of Problem.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="comments2" class="form-label">Comments<span class="text-muted"> (Optional)</span></label>
                          <textarea class="form-control" id="comments2" placeholder="Feel free to leave any additional comments here" rows="4" value={this.state.comments2} onChange={this.comments2ChangeEvent}></textarea>
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="attachments2" class="form-label">Attachments<span class="text-muted"> (Optional)</span></label>
                          <input class="form-control" type="file" id="attachments2" value={this.state.attachments2} onChange={this.attachments2ChangeEvent} multiple />
                        </div>
                        
                        <hr class="my-4 mb-0" />

                      </div>

                      <div class={`${this.state.product_count >= 3 ? 'row g-3 ms-0 me-0 p-0 collapse show' : 'collapse'}`} >
                        <div class="col-12">
                          <h4 class="mt-3 mb-3">Product Details (3)</h4>
                        </div>

                        <div class="col-12">
                          <label for="jobNumber3" class="form-label">Job Number<span class="text-muted"> (Located below Mains ON/OFF MCB)</span></label>
                          <input type="text" class="form-control" id="jobNumber3" placeholder="2526-JS001" value={this.state.jobNumber3} onChange={this.jobNumber3ChangeEvent} required={this.state.product_count>=3} />
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="serialNumber3" class="form-label">Serial Number<span class="text-muted"> (Located at back side of panel near input supply)</span></label>
                          <input type="text" class="form-control" id="serialNumber3" placeholder="2502001" value={this.state.serialNumber3} onChange={this.serialNumber3ChangeEvent} required={this.state.product_count>=3} />
                          <div class="invalid-feedback">
                            Please enter the Serial Number of equipment. It is located at back side of panel near input supply.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="nameOfEquipment3" class="form-label">Name of equipment</label>
                          <input type="text" class="form-control" id="nameOfEquipment3" placeholder="Glow Wire Test Apparatus" value={this.state.nameOfEquipment3} onChange={this.nameOfEquipment3ChangeEvent} required={this.state.product_count>=3} />
                          <div class="invalid-feedback">
                            Please enter the Name of equipment.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="natureOfProblem3" class="form-label">Nature of Problem</label>
                          <textarea class="form-control" id="natureOfProblem3" placeholder="Please describe the problem faced in Panel" rows="4" value={this.state.natureOfProblem3} onChange={this.natureOfProblem3ChangeEvent} required={this.state.product_count>=3} ></textarea>
                          <div class="invalid-feedback">
                            Please enter Nature of Problem.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="comments3" class="form-label">Comments<span class="text-muted"> (Optional)</span></label>
                          <textarea class="form-control" id="comments3" placeholder="Feel free to leave any additional comments here" rows="4" value={this.state.comments3} onChange={this.comments3ChangeEvent}></textarea>
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="attachments3" class="form-label">Attachments<span class="text-muted"> (Optional)</span></label>
                          <input class="form-control" type="file" id="attachments3" value={this.state.attachments3} onChange={this.attachments3ChangeEvent} multiple />
                        </div>
                        
                        <hr class="my-4 mb-0" />

                      </div>
                      
                      <div class={`${this.state.product_count >= 4 ? 'row g-3 ms-0 me-0 p-0 collapse show' : 'collapse'}`} >
                        <div class="col-12">
                          <h4 class="mt-3 mb-3">Product Details (4)</h4>
                        </div>

                        <div class="col-12">
                          <label for="jobNumber4" class="form-label">Job Number<span class="text-muted"> (Located below Mains ON/OFF MCB)</span></label>
                          <input type="text" class="form-control" id="jobNumber4" placeholder="2526-JS001" value={this.state.jobNumber4} onChange={this.jobNumber4ChangeEvent} required={this.state.product_count>=4} />
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="serialNumber4" class="form-label">Serial Number<span class="text-muted"> (Located at back side of panel near input supply)</span></label>
                          <input type="text" class="form-control" id="serialNumber4" placeholder="2502001" value={this.state.serialNumber4} onChange={this.serialNumber4ChangeEvent} required={this.state.product_count>=4} />
                          <div class="invalid-feedback">
                            Please enter the Serial Number of equipment. It is located at back side of panel near input supply.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="nameOfEquipment4" class="form-label">Name of equipment</label>
                          <input type="text" class="form-control" id="nameOfEquipment4" placeholder="Glow Wire Test Apparatus" value={this.state.nameOfEquipment4} onChange={this.nameOfEquipment4ChangeEvent} required={this.state.product_count>=4} />
                          <div class="invalid-feedback">
                            Please enter the Name of equipment.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="natureOfProblem4" class="form-label">Nature of Problem</label>
                          <textarea class="form-control" id="natureOfProblem4" placeholder="Please describe the problem faced in Panel" rows="4" value={this.state.natureOfProblem4} onChange={this.natureOfProblem4ChangeEvent} required={this.state.product_count>=4} ></textarea>
                          <div class="invalid-feedback">
                            Please enter Nature of Problem.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="comments4" class="form-label">Comments<span class="text-muted"> (Optional)</span></label>
                          <textarea class="form-control" id="comments4" placeholder="Feel free to leave any additional comments here" rows="4" value={this.state.comments4} onChange={this.comments4ChangeEvent}></textarea>
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="attachments4" class="form-label">Attachments<span class="text-muted"> (Optional)</span></label>
                          <input class="form-control" type="file" id="attachments4" value={this.state.attachments4} onChange={this.attachments4ChangeEvent} multiple />
                        </div>
                        
                        <hr class="my-4 mb-0" />

                      </div>

                      <div class={`${this.state.product_count >= 5 ? 'row g-3 ms-0 me-0 p-0 collapse show' : 'collapse'}`} >
                        <div class="col-12">
                          <h4 class="mt-3 mb-3">Product Details (5)</h4>
                        </div>

                        <div class="col-12">
                          <label for="jobNumber5" class="form-label">Job Number<span class="text-muted"> (Located below Mains ON/OFF MCB)</span></label>
                          <input type="text" class="form-control" id="jobNumber5" placeholder="2526-JS001" value={this.state.jobNumber5} onChange={this.jobNumber5ChangeEvent} required={this.state.product_count>=5} />
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="serialNumber5" class="form-label">Serial Number<span class="text-muted"> (Located at back side of panel near input supply)</span></label>
                          <input type="text" class="form-control" id="serialNumber5" placeholder="2502001" value={this.state.serialNumber5} onChange={this.serialNumber5ChangeEvent} required={this.state.product_count>=5} />
                          <div class="invalid-feedback">
                            Please enter the Serial Number of equipment. It is located at back side of panel near input supply.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="nameOfEquipment5" class="form-label">Name of equipment</label>
                          <input type="text" class="form-control" id="nameOfEquipment5" placeholder="Glow Wire Test Apparatus" value={this.state.nameOfEquipment5} onChange={this.nameOfEquipment5ChangeEvent} required={this.state.product_count>=5} />
                          <div class="invalid-feedback">
                            Please enter the Name of equipment.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="natureOfProblem5" class="form-label">Nature of Problem</label>
                          <textarea class="form-control" id="natureOfProblem5" placeholder="Please describe the problem faced in Panel" rows="4" value={this.state.natureOfProblem5} onChange={this.natureOfProblem5ChangeEvent} required={this.state.product_count>=5} ></textarea>
                          <div class="invalid-feedback">
                            Please enter Nature of Problem.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="comments5" class="form-label">Comments<span class="text-muted"> (Optional)</span></label>
                          <textarea class="form-control" id="comments5" placeholder="Feel free to leave any additional comments here" rows="4" value={this.state.comments5} onChange={this.comments5ChangeEvent}></textarea>
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="attachments5" class="form-label">Attachments<span class="text-muted"> (Optional)</span></label>
                          <input class="form-control" type="file" id="attachments5" value={this.state.attachments5} onChange={this.attachments5ChangeEvent} multiple />
                        </div>
                        
                        <hr class="my-4 mb-0" />

                      </div>

                      <div class={`${this.state.product_count >= 6 ? 'row g-3 ms-0 me-0 p-0 collapse show' : 'collapse'}`} >
                        <div class="col-12">
                          <h4 class="mt-3 mb-3">Product Details (6)</h4>
                        </div>

                        <div class="col-12">
                          <label for="jobNumber6" class="form-label">Job Number<span class="text-muted"> (Located below Mains ON/OFF MCB)</span></label>
                          <input type="text" class="form-control" id="jobNumber6" placeholder="2526-JS001" value={this.state.jobNumber6} onChange={this.jobNumber6ChangeEvent} required={this.state.product_count>=6} />
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="serialNumber6" class="form-label">Serial Number<span class="text-muted"> (Located at back side of panel near input supply)</span></label>
                          <input type="text" class="form-control" id="serialNumber6" placeholder="2502001" value={this.state.serialNumber6} onChange={this.serialNumber6ChangeEvent} required={this.state.product_count>=6} />
                          <div class="invalid-feedback">
                            Please enter the Serial Number of equipment. It is located at back side of panel near input supply.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="nameOfEquipment6" class="form-label">Name of equipment</label>
                          <input type="text" class="form-control" id="nameOfEquipment6" placeholder="Glow Wire Test Apparatus" value={this.state.nameOfEquipment6} onChange={this.nameOfEquipment6ChangeEvent} required={this.state.product_count>=6} />
                          <div class="invalid-feedback">
                            Please enter the Name of equipment.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="natureOfProblem6" class="form-label">Nature of Problem</label>
                          <textarea class="form-control" id="natureOfProblem6" placeholder="Please describe the problem faced in Panel" rows="4" value={this.state.natureOfProblem6} onChange={this.natureOfProblem6ChangeEvent} required={this.state.product_count>=6} ></textarea>
                          <div class="invalid-feedback">
                            Please enter Nature of Problem.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="comments6" class="form-label">Comments<span class="text-muted"> (Optional)</span></label>
                          <textarea class="form-control" id="comments6" placeholder="Feel free to leave any additional comments here" rows="4" value={this.state.comments6} onChange={this.comments6ChangeEvent}></textarea>
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="attachments6" class="form-label">Attachments<span class="text-muted"> (Optional)</span></label>
                          <input class="form-control" type="file" id="attachments6" value={this.state.attachments6} onChange={this.attachments6ChangeEvent} multiple />
                        </div>
                        
                        <hr class="my-4 mb-0" />

                      </div>

                      <div class={`${this.state.product_count >= 7 ? 'row g-3 ms-0 me-0 p-0 collapse show' : 'collapse'}`} >
                        <div class="col-12">
                          <h4 class="mt-3 mb-3">Product Details (7)</h4>
                        </div>

                        <div class="col-12">
                          <label for="jobNumber7" class="form-label">Job Number<span class="text-muted"> (Located below Mains ON/OFF MCB)</span></label>
                          <input type="text" class="form-control" id="jobNumber7" placeholder="2526-JS001" value={this.state.jobNumber7} onChange={this.jobNumber7ChangeEvent} required={this.state.product_count>=7} />
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="serialNumber7" class="form-label">Serial Number<span class="text-muted"> (Located at back side of panel near input supply)</span></label>
                          <input type="text" class="form-control" id="serialNumber7" placeholder="2502001" value={this.state.serialNumber7} onChange={this.serialNumber7ChangeEvent} required={this.state.product_count>=7} />
                          <div class="invalid-feedback">
                            Please enter the Serial Number of equipment. It is located at back side of panel near input supply.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="nameOfEquipment7" class="form-label">Name of equipment</label>
                          <input type="text" class="form-control" id="nameOfEquipment7" placeholder="Glow Wire Test Apparatus" value={this.state.nameOfEquipment7} onChange={this.nameOfEquipment7ChangeEvent} required={this.state.product_count>=7} />
                          <div class="invalid-feedback">
                            Please enter the Name of equipment.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="natureOfProblem7" class="form-label">Nature of Problem</label>
                          <textarea class="form-control" id="natureOfProblem7" placeholder="Please describe the problem faced in Panel" rows="4" value={this.state.natureOfProblem7} onChange={this.natureOfProblem7ChangeEvent} required={this.state.product_count>=7} ></textarea>
                          <div class="invalid-feedback">
                            Please enter Nature of Problem.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="comments7" class="form-label">Comments<span class="text-muted"> (Optional)</span></label>
                          <textarea class="form-control" id="comments7" placeholder="Feel free to leave any additional comments here" rows="4" value={this.state.comments7} onChange={this.comments7ChangeEvent}></textarea>
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="attachments7" class="form-label">Attachments<span class="text-muted"> (Optional)</span></label>
                          <input class="form-control" type="file" id="attachments7" value={this.state.attachments7} onChange={this.attachments7ChangeEvent} multiple />
                        </div>
                        
                        <hr class="my-4 mb-0" />

                      </div>

                      <div class={`${this.state.product_count >= 8 ? 'row g-3 ms-0 me-0 p-0 collapse show' : 'collapse'}`} >
                        <div class="col-12">
                          <h4 class="mt-3 mb-3">Product Details (8)</h4>
                        </div>

                        <div class="col-12">
                          <label for="jobNumber8" class="form-label">Job Number<span class="text-muted"> (Located below Mains ON/OFF MCB)</span></label>
                          <input type="text" class="form-control" id="jobNumber8" placeholder="2526-JS001" value={this.state.jobNumber8} onChange={this.jobNumber8ChangeEvent} required={this.state.product_count>=8} />
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="serialNumber8" class="form-label">Serial Number<span class="text-muted"> (Located at back side of panel near input supply)</span></label>
                          <input type="text" class="form-control" id="serialNumber8" placeholder="2502001" value={this.state.serialNumber8} onChange={this.serialNumber8ChangeEvent} required={this.state.product_count>=8} />
                          <div class="invalid-feedback">
                            Please enter the Serial Number of equipment. It is located at back side of panel near input supply.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="nameOfEquipment8" class="form-label">Name of equipment</label>
                          <input type="text" class="form-control" id="nameOfEquipment8" placeholder="Glow Wire Test Apparatus" value={this.state.nameOfEquipment8} onChange={this.nameOfEquipment8ChangeEvent} required={this.state.product_count>=8} />
                          <div class="invalid-feedback">
                            Please enter the Name of equipment.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="natureOfProblem8" class="form-label">Nature of Problem</label>
                          <textarea class="form-control" id="natureOfProblem8" placeholder="Please describe the problem faced in Panel" rows="4" value={this.state.natureOfProblem8} onChange={this.natureOfProblem8ChangeEvent} required={this.state.product_count>=8} ></textarea>
                          <div class="invalid-feedback">
                            Please enter Nature of Problem.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="comments8" class="form-label">Comments<span class="text-muted"> (Optional)</span></label>
                          <textarea class="form-control" id="comments8" placeholder="Feel free to leave any additional comments here" rows="4" value={this.state.comments8} onChange={this.comments8ChangeEvent}></textarea>
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="attachments8" class="form-label">Attachments<span class="text-muted"> (Optional)</span></label>
                          <input class="form-control" type="file" id="attachments8" value={this.state.attachments8} onChange={this.attachments8ChangeEvent} multiple />
                        </div>
                        
                        <hr class="my-4 mb-0" />

                      </div>

                      <div class={`${this.state.product_count >= 9 ? 'row g-3 ms-0 me-0 p-0 collapse show' : 'collapse'}`} >
                        <div class="col-12">
                          <h4 class="mt-3 mb-3">Product Details (9)</h4>
                        </div>

                        <div class="col-12">
                          <label for="jobNumber9" class="form-label">Job Number<span class="text-muted"> (Located below Mains ON/OFF MCB)</span></label>
                          <input type="text" class="form-control" id="jobNumber9" placeholder="2526-JS001" value={this.state.jobNumber9} onChange={this.jobNumber9ChangeEvent} required={this.state.product_count>=9} />
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="serialNumber9" class="form-label">Serial Number<span class="text-muted"> (Located at back side of panel near input supply)</span></label>
                          <input type="text" class="form-control" id="serialNumber9" placeholder="2502001" value={this.state.serialNumber9} onChange={this.serialNumber9ChangeEvent} required={this.state.product_count>=9} />
                          <div class="invalid-feedback">
                            Please enter the Serial Number of equipment. It is located at back side of panel near input supply.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="nameOfEquipment9" class="form-label">Name of equipment</label>
                          <input type="text" class="form-control" id="nameOfEquipment9" placeholder="Glow Wire Test Apparatus" value={this.state.nameOfEquipment9} onChange={this.nameOfEquipment9ChangeEvent} required={this.state.product_count>=9} />
                          <div class="invalid-feedback">
                            Please enter the Name of equipment.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="natureOfProblem9" class="form-label">Nature of Problem</label>
                          <textarea class="form-control" id="natureOfProblem9" placeholder="Please describe the problem faced in Panel" rows="4" value={this.state.natureOfProblem9} onChange={this.natureOfProblem9ChangeEvent} required={this.state.product_count>=9} ></textarea>
                          <div class="invalid-feedback">
                            Please enter Nature of Problem.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="comments9" class="form-label">Comments<span class="text-muted"> (Optional)</span></label>
                          <textarea class="form-control" id="comments9" placeholder="Feel free to leave any additional comments here" rows="4" value={this.state.comments9} onChange={this.comments9ChangeEvent}></textarea>
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="attachments9" class="form-label">Attachments<span class="text-muted"> (Optional)</span></label>
                          <input class="form-control" type="file" id="attachments9" value={this.state.attachments9} onChange={this.attachments9ChangeEvent} multiple />
                        </div>
                        
                        <hr class="my-4 mb-0" />

                      </div>

                      <div class={`${this.state.product_count >= 10 ? 'row g-3 ms-0 me-0 p-0 collapse show' : 'collapse'}`} >
                        <div class="col-12">
                          <h4 class="mt-3 mb-3">Product Details (10)</h4>
                        </div>

                        <div class="col-12">
                          <label for="jobNumber10" class="form-label">Job Number<span class="text-muted"> (Located below Mains ON/OFF MCB)</span></label>
                          <input type="text" class="form-control" id="jobNumber10" placeholder="2526-JS001" value={this.state.jobNumber10} onChange={this.jobNumber10ChangeEvent} required={this.state.product_count>=10} />
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="serialNumber10" class="form-label">Serial Number<span class="text-muted"> (Located at back side of panel near input supply)</span></label>
                          <input type="text" class="form-control" id="serialNumber10" placeholder="2502001" value={this.state.serialNumber10} onChange={this.serialNumber10ChangeEvent} required={this.state.product_count>=10} />
                          <div class="invalid-feedback">
                            Please enter the Serial Number of equipment. It is located at back side of panel near input supply.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="nameOfEquipment10" class="form-label">Name of equipment</label>
                          <input type="text" class="form-control" id="nameOfEquipment10" placeholder="Glow Wire Test Apparatus" value={this.state.nameOfEquipment10} onChange={this.nameOfEquipment10ChangeEvent} required={this.state.product_count>=10} />
                          <div class="invalid-feedback">
                            Please enter the Name of equipment.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="natureOfProblem10" class="form-label">Nature of Problem</label>
                          <textarea class="form-control" id="natureOfProblem10" placeholder="Please describe the problem faced in Panel" rows="4" value={this.state.natureOfProblem10} onChange={this.natureOfProblem10ChangeEvent} required={this.state.product_count>=10} ></textarea>
                          <div class="invalid-feedback">
                            Please enter Nature of Problem.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="comments10" class="form-label">Comments<span class="text-muted"> (Optional)</span></label>
                          <textarea class="form-control" id="comments10" placeholder="Feel free to leave any additional comments here" rows="4" value={this.state.comments10} onChange={this.comments10ChangeEvent}></textarea>
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="attachments10" class="form-label">Attachments<span class="text-muted"> (Optional)</span></label>
                          <input class="form-control" type="file" id="attachments10" value={this.state.attachments10} onChange={this.attachments10ChangeEvent} multiple />
                        </div>
                        
                        <hr class="my-4 mb-0" />

                      </div>

                      <div class={`${this.state.product_count >= 11 ? 'row g-3 ms-0 me-0 p-0 collapse show' : 'collapse'}`} >
                        <div class="col-12">
                          <h4 class="mt-3 mb-3">Product Details (11)</h4>
                        </div>

                        <div class="col-12">
                          <label for="jobNumber11" class="form-label">Job Number<span class="text-muted"> (Located below Mains ON/OFF MCB)</span></label>
                          <input type="text" class="form-control" id="jobNumber11" placeholder="2526-JS001" value={this.state.jobNumber11} onChange={this.jobNumber11ChangeEvent} required={this.state.product_count>=11} />
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="serialNumber11" class="form-label">Serial Number<span class="text-muted"> (Located at back side of panel near input supply)</span></label>
                          <input type="text" class="form-control" id="serialNumber11" placeholder="2502001" value={this.state.serialNumber11} onChange={this.serialNumber11ChangeEvent} required={this.state.product_count>=11} />
                          <div class="invalid-feedback">
                            Please enter the Serial Number of equipment. It is located at back side of panel near input supply.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="nameOfEquipment11" class="form-label">Name of equipment</label>
                          <input type="text" class="form-control" id="nameOfEquipment11" placeholder="Glow Wire Test Apparatus" value={this.state.nameOfEquipment11} onChange={this.nameOfEquipment11ChangeEvent} required={this.state.product_count>=11} />
                          <div class="invalid-feedback">
                            Please enter the Name of equipment.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="natureOfProblem11" class="form-label">Nature of Problem</label>
                          <textarea class="form-control" id="natureOfProblem11" placeholder="Please describe the problem faced in Panel" rows="4" value={this.state.natureOfProblem11} onChange={this.natureOfProblem11ChangeEvent} required={this.state.product_count>=11} ></textarea>
                          <div class="invalid-feedback">
                            Please enter Nature of Problem.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="comments11" class="form-label">Comments<span class="text-muted"> (Optional)</span></label>
                          <textarea class="form-control" id="comments11" placeholder="Feel free to leave any additional comments here" rows="4" value={this.state.comments11} onChange={this.comments11ChangeEvent}></textarea>
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="attachments11" class="form-label">Attachments<span class="text-muted"> (Optional)</span></label>
                          <input class="form-control" type="file" id="attachments11" value={this.state.attachments11} onChange={this.attachments11ChangeEvent} multiple />
                        </div>
                        
                        <hr class="my-4 mb-0" />

                      </div>

                      <div class={`${this.state.product_count >= 12 ? 'row g-3 ms-0 me-0 p-0 collapse show' : 'collapse'}`} >
                        <div class="col-12">
                          <h4 class="mt-3 mb-3">Product Details (12)</h4>
                        </div>

                        <div class="col-12">
                          <label for="jobNumber12" class="form-label">Job Number<span class="text-muted"> (Located below Mains ON/OFF MCB)</span></label>
                          <input type="text" class="form-control" id="jobNumber12" placeholder="2526-JS001" value={this.state.jobNumber12} onChange={this.jobNumber12ChangeEvent} required={this.state.product_count>=12} />
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="serialNumber12" class="form-label">Serial Number<span class="text-muted"> (Located at back side of panel near input supply)</span></label>
                          <input type="text" class="form-control" id="serialNumber12" placeholder="2502001" value={this.state.serialNumber12} onChange={this.serialNumber12ChangeEvent} required={this.state.product_count>=12} />
                          <div class="invalid-feedback">
                            Please enter the Serial Number of equipment. It is located at back side of panel near input supply.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="nameOfEquipment12" class="form-label">Name of equipment</label>
                          <input type="text" class="form-control" id="nameOfEquipment12" placeholder="Glow Wire Test Apparatus" value={this.state.nameOfEquipment12} onChange={this.nameOfEquipment12ChangeEvent} required={this.state.product_count>=12} />
                          <div class="invalid-feedback">
                            Please enter the Name of equipment.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="natureOfProblem12" class="form-label">Nature of Problem</label>
                          <textarea class="form-control" id="natureOfProblem12" placeholder="Please describe the problem faced in Panel" rows="4" value={this.state.natureOfProblem12} onChange={this.natureOfProblem12ChangeEvent} required={this.state.product_count>=12} ></textarea>
                          <div class="invalid-feedback">
                            Please enter Nature of Problem.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="comments12" class="form-label">Comments<span class="text-muted"> (Optional)</span></label>
                          <textarea class="form-control" id="comments12" placeholder="Feel free to leave any additional comments here" rows="4" value={this.state.comments12} onChange={this.comments12ChangeEvent}></textarea>
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="attachments12" class="form-label">Attachments<span class="text-muted"> (Optional)</span></label>
                          <input class="form-control" type="file" id="attachments12" value={this.state.attachments12} onChange={this.attachments12ChangeEvent} multiple />
                        </div>
                        
                        <hr class="my-4 mb-0" />

                      </div>

                      <div class={`${this.state.product_count >= 13 ? 'row g-3 ms-0 me-0 p-0 collapse show' : 'collapse'}`} >
                        <div class="col-12">
                          <h4 class="mt-3 mb-3">Product Details (13)</h4>
                        </div>

                        <div class="col-12">
                          <label for="jobNumber13" class="form-label">Job Number<span class="text-muted"> (Located below Mains ON/OFF MCB)</span></label>
                          <input type="text" class="form-control" id="jobNumber13" placeholder="2526-JS001" value={this.state.jobNumber13} onChange={this.jobNumber13ChangeEvent} required={this.state.product_count>=13} />
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="serialNumber13" class="form-label">Serial Number<span class="text-muted"> (Located at back side of panel near input supply)</span></label>
                          <input type="text" class="form-control" id="serialNumber13" placeholder="2502001" value={this.state.serialNumber13} onChange={this.serialNumber13ChangeEvent} required={this.state.product_count>=13} />
                          <div class="invalid-feedback">
                            Please enter the Serial Number of equipment. It is located at back side of panel near input supply.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="nameOfEquipment13" class="form-label">Name of equipment</label>
                          <input type="text" class="form-control" id="nameOfEquipment13" placeholder="Glow Wire Test Apparatus" value={this.state.nameOfEquipment13} onChange={this.nameOfEquipment13ChangeEvent} required={this.state.product_count>=13} />
                          <div class="invalid-feedback">
                            Please enter the Name of equipment.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="natureOfProblem13" class="form-label">Nature of Problem</label>
                          <textarea class="form-control" id="natureOfProblem13" placeholder="Please describe the problem faced in Panel" rows="4" value={this.state.natureOfProblem13} onChange={this.natureOfProblem13ChangeEvent} required={this.state.product_count>=13} ></textarea>
                          <div class="invalid-feedback">
                            Please enter Nature of Problem.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="comments13" class="form-label">Comments<span class="text-muted"> (Optional)</span></label>
                          <textarea class="form-control" id="comments13" placeholder="Feel free to leave any additional comments here" rows="4" value={this.state.comments13} onChange={this.comments13ChangeEvent}></textarea>
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="attachments13" class="form-label">Attachments<span class="text-muted"> (Optional)</span></label>
                          <input class="form-control" type="file" id="attachments13" value={this.state.attachments13} onChange={this.attachments13ChangeEvent} multiple />
                        </div>
                        
                        <hr class="my-4 mb-0" />

                      </div>

                      <div class={`${this.state.product_count >= 14 ? 'row g-3 ms-0 me-0 p-0 collapse show' : 'collapse'}`} >
                        <div class="col-12">
                          <h4 class="mt-3 mb-3">Product Details (14)</h4>
                        </div>

                        <div class="col-12">
                          <label for="jobNumber14" class="form-label">Job Number<span class="text-muted"> (Located below Mains ON/OFF MCB)</span></label>
                          <input type="text" class="form-control" id="jobNumber14" placeholder="2526-JS001" value={this.state.jobNumber14} onChange={this.jobNumber14ChangeEvent} required={this.state.product_count>=14} />
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="serialNumber14" class="form-label">Serial Number<span class="text-muted"> (Located at back side of panel near input supply)</span></label>
                          <input type="text" class="form-control" id="serialNumber14" placeholder="2502001" value={this.state.serialNumber14} onChange={this.serialNumber14ChangeEvent} required={this.state.product_count>=14} />
                          <div class="invalid-feedback">
                            Please enter the Serial Number of equipment. It is located at back side of panel near input supply.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="nameOfEquipment14" class="form-label">Name of equipment</label>
                          <input type="text" class="form-control" id="nameOfEquipment14" placeholder="Glow Wire Test Apparatus" value={this.state.nameOfEquipment14} onChange={this.nameOfEquipment14ChangeEvent} required={this.state.product_count>=14} />
                          <div class="invalid-feedback">
                            Please enter the Name of equipment.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="natureOfProblem14" class="form-label">Nature of Problem</label>
                          <textarea class="form-control" id="natureOfProblem14" placeholder="Please describe the problem faced in Panel" rows="4" value={this.state.natureOfProblem14} onChange={this.natureOfProblem14ChangeEvent} required={this.state.product_count>=14} ></textarea>
                          <div class="invalid-feedback">
                            Please enter Nature of Problem.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="comments14" class="form-label">Comments<span class="text-muted"> (Optional)</span></label>
                          <textarea class="form-control" id="comments14" placeholder="Feel free to leave any additional comments here" rows="4" value={this.state.comments14} onChange={this.comments14ChangeEvent}></textarea>
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="attachments14" class="form-label">Attachments<span class="text-muted"> (Optional)</span></label>
                          <input class="form-control" type="file" id="attachments14" value={this.state.attachments14} onChange={this.attachments14ChangeEvent} multiple />
                        </div>
                        
                        <hr class="my-4 mb-0" />

                      </div>

                      <div class={`${this.state.product_count >= 15 ? 'row g-3 ms-0 me-0 p-0 collapse show' : 'collapse'}`} >
                        <div class="col-12">
                          <h4 class="mt-3 mb-3">Product Details (15)</h4>
                        </div>

                        <div class="col-12">
                          <label for="jobNumber15" class="form-label">Job Number<span class="text-muted"> (Located below Mains ON/OFF MCB)</span></label>
                          <input type="text" class="form-control" id="jobNumber15" placeholder="2526-JS001" value={this.state.jobNumber15} onChange={this.jobNumber15ChangeEvent} required={this.state.product_count>=15} />
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="serialNumber15" class="form-label">Serial Number<span class="text-muted"> (Located at back side of panel near input supply)</span></label>
                          <input type="text" class="form-control" id="serialNumber15" placeholder="2502001" value={this.state.serialNumber15} onChange={this.serialNumber15ChangeEvent} required={this.state.product_count>=15} />
                          <div class="invalid-feedback">
                            Please enter the Serial Number of equipment. It is located at back side of panel near input supply.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="nameOfEquipment15" class="form-label">Name of equipment</label>
                          <input type="text" class="form-control" id="nameOfEquipment15" placeholder="Glow Wire Test Apparatus" value={this.state.nameOfEquipment15} onChange={this.nameOfEquipment15ChangeEvent} required={this.state.product_count>=15} />
                          <div class="invalid-feedback">
                            Please enter the Name of equipment.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="natureOfProblem15" class="form-label">Nature of Problem</label>
                          <textarea class="form-control" id="natureOfProblem15" placeholder="Please describe the problem faced in Panel" rows="4" value={this.state.natureOfProblem15} onChange={this.natureOfProblem15ChangeEvent} required={this.state.product_count>=15} ></textarea>
                          <div class="invalid-feedback">
                            Please enter Nature of Problem.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="comments15" class="form-label">Comments<span class="text-muted"> (Optional)</span></label>
                          <textarea class="form-control" id="comments15" placeholder="Feel free to leave any additional comments here" rows="4" value={this.state.comments15} onChange={this.comments15ChangeEvent}></textarea>
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="attachments15" class="form-label">Attachments<span class="text-muted"> (Optional)</span></label>
                          <input class="form-control" type="file" id="attachments15" value={this.state.attachments15} onChange={this.attachments15ChangeEvent} multiple />
                        </div>
                        
                        <hr class="my-4 mb-0" />

                      </div>

                      <div class={`${this.state.product_count >= 16 ? 'row g-3 ms-0 me-0 p-0 collapse show' : 'collapse'}`} >
                        <div class="col-12">
                          <h4 class="mt-3 mb-3">Product Details (16)</h4>
                        </div>

                        <div class="col-12">
                          <label for="jobNumber16" class="form-label">Job Number<span class="text-muted"> (Located below Mains ON/OFF MCB)</span></label>
                          <input type="text" class="form-control" id="jobNumber16" placeholder="2526-JS001" value={this.state.jobNumber16} onChange={this.jobNumber16ChangeEvent} required={this.state.product_count>=16} />
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="serialNumber16" class="form-label">Serial Number<span class="text-muted"> (Located at back side of panel near input supply)</span></label>
                          <input type="text" class="form-control" id="serialNumber16" placeholder="2502001" value={this.state.serialNumber16} onChange={this.serialNumber16ChangeEvent} required={this.state.product_count>=16} />
                          <div class="invalid-feedback">
                            Please enter the Serial Number of equipment. It is located at back side of panel near input supply.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="nameOfEquipment16" class="form-label">Name of equipment</label>
                          <input type="text" class="form-control" id="nameOfEquipment16" placeholder="Glow Wire Test Apparatus" value={this.state.nameOfEquipment16} onChange={this.nameOfEquipment16ChangeEvent} required={this.state.product_count>=16} />
                          <div class="invalid-feedback">
                            Please enter the Name of equipment.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="natureOfProblem16" class="form-label">Nature of Problem</label>
                          <textarea class="form-control" id="natureOfProblem16" placeholder="Please describe the problem faced in Panel" rows="4" value={this.state.natureOfProblem16} onChange={this.natureOfProblem16ChangeEvent} required={this.state.product_count>=16} ></textarea>
                          <div class="invalid-feedback">
                            Please enter Nature of Problem.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="comments16" class="form-label">Comments<span class="text-muted"> (Optional)</span></label>
                          <textarea class="form-control" id="comments16" placeholder="Feel free to leave any additional comments here" rows="4" value={this.state.comments16} onChange={this.comments16ChangeEvent}></textarea>
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="attachments16" class="form-label">Attachments<span class="text-muted"> (Optional)</span></label>
                          <input class="form-control" type="file" id="attachments16" value={this.state.attachments16} onChange={this.attachments16ChangeEvent} multiple />
                        </div>
                        
                        <hr class="my-4 mb-0" />

                      </div>

                      <div class={`${this.state.product_count >= 17 ? 'row g-3 ms-0 me-0 p-0 collapse show' : 'collapse'}`} >
                        <div class="col-12">
                          <h4 class="mt-3 mb-3">Product Details (17)</h4>
                        </div>

                        <div class="col-12">
                          <label for="jobNumber17" class="form-label">Job Number<span class="text-muted"> (Located below Mains ON/OFF MCB)</span></label>
                          <input type="text" class="form-control" id="jobNumber17" placeholder="2526-JS001" value={this.state.jobNumber17} onChange={this.jobNumber17ChangeEvent} required={this.state.product_count>=17} />
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="serialNumber17" class="form-label">Serial Number<span class="text-muted"> (Located at back side of panel near input supply)</span></label>
                          <input type="text" class="form-control" id="serialNumber17" placeholder="2502001" value={this.state.serialNumber17} onChange={this.serialNumber17ChangeEvent} required={this.state.product_count>=17} />
                          <div class="invalid-feedback">
                            Please enter the Serial Number of equipment. It is located at back side of panel near input supply.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="nameOfEquipment17" class="form-label">Name of equipment</label>
                          <input type="text" class="form-control" id="nameOfEquipment17" placeholder="Glow Wire Test Apparatus" value={this.state.nameOfEquipment17} onChange={this.nameOfEquipment17ChangeEvent} required={this.state.product_count>=17} />
                          <div class="invalid-feedback">
                            Please enter the Name of equipment.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="natureOfProblem17" class="form-label">Nature of Problem</label>
                          <textarea class="form-control" id="natureOfProblem17" placeholder="Please describe the problem faced in Panel" rows="4" value={this.state.natureOfProblem17} onChange={this.natureOfProblem17ChangeEvent} required={this.state.product_count>=17} ></textarea>
                          <div class="invalid-feedback">
                            Please enter Nature of Problem.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="comments17" class="form-label">Comments<span class="text-muted"> (Optional)</span></label>
                          <textarea class="form-control" id="comments17" placeholder="Feel free to leave any additional comments here" rows="4" value={this.state.comments17} onChange={this.comments17ChangeEvent}></textarea>
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="attachments17" class="form-label">Attachments<span class="text-muted"> (Optional)</span></label>
                          <input class="form-control" type="file" id="attachments17" value={this.state.attachments17} onChange={this.attachments17ChangeEvent} multiple />
                        </div>
                        
                        <hr class="my-4 mb-0" />

                      </div>

                      <div class={`${this.state.product_count >= 18 ? 'row g-3 ms-0 me-0 p-0 collapse show' : 'collapse'}`} >
                        <div class="col-12">
                          <h4 class="mt-3 mb-3">Product Details (18)</h4>
                        </div>

                        <div class="col-12">
                          <label for="jobNumber18" class="form-label">Job Number<span class="text-muted"> (Located below Mains ON/OFF MCB)</span></label>
                          <input type="text" class="form-control" id="jobNumber18" placeholder="2526-JS001" value={this.state.jobNumber18} onChange={this.jobNumber18ChangeEvent} required={this.state.product_count>=18} />
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="serialNumber18" class="form-label">Serial Number<span class="text-muted"> (Located at back side of panel near input supply)</span></label>
                          <input type="text" class="form-control" id="serialNumber18" placeholder="2502001" value={this.state.serialNumber18} onChange={this.serialNumber18ChangeEvent} required={this.state.product_count>=18} />
                          <div class="invalid-feedback">
                            Please enter the Serial Number of equipment. It is located at back side of panel near input supply.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="nameOfEquipment18" class="form-label">Name of equipment</label>
                          <input type="text" class="form-control" id="nameOfEquipment18" placeholder="Glow Wire Test Apparatus" value={this.state.nameOfEquipment18} onChange={this.nameOfEquipment18ChangeEvent} required={this.state.product_count>=18} />
                          <div class="invalid-feedback">
                            Please enter the Name of equipment.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="natureOfProblem18" class="form-label">Nature of Problem</label>
                          <textarea class="form-control" id="natureOfProblem18" placeholder="Please describe the problem faced in Panel" rows="4" value={this.state.natureOfProblem18} onChange={this.natureOfProblem18ChangeEvent} required={this.state.product_count>=18} ></textarea>
                          <div class="invalid-feedback">
                            Please enter Nature of Problem.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="comments18" class="form-label">Comments<span class="text-muted"> (Optional)</span></label>
                          <textarea class="form-control" id="comments18" placeholder="Feel free to leave any additional comments here" rows="4" value={this.state.comments18} onChange={this.comments18ChangeEvent}></textarea>
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="attachments18" class="form-label">Attachments<span class="text-muted"> (Optional)</span></label>
                          <input class="form-control" type="file" id="attachments18" value={this.state.attachments18} onChange={this.attachments18ChangeEvent} multiple />
                        </div>
                        
                        <hr class="my-4 mb-0" />

                      </div>

                      <div class={`${this.state.product_count >= 19 ? 'row g-3 ms-0 me-0 p-0 collapse show' : 'collapse'}`} >
                        <div class="col-12">
                          <h4 class="mt-3 mb-3">Product Details (19)</h4>
                        </div>

                        <div class="col-12">
                          <label for="jobNumber19" class="form-label">Job Number<span class="text-muted"> (Located below Mains ON/OFF MCB)</span></label>
                          <input type="text" class="form-control" id="jobNumber19" placeholder="2526-JS001" value={this.state.jobNumber19} onChange={this.jobNumber19ChangeEvent} required={this.state.product_count>=19} />
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="serialNumber19" class="form-label">Serial Number<span class="text-muted"> (Located at back side of panel near input supply)</span></label>
                          <input type="text" class="form-control" id="serialNumber19" placeholder="2502001" value={this.state.serialNumber19} onChange={this.serialNumber19ChangeEvent} required={this.state.product_count>=19} />
                          <div class="invalid-feedback">
                            Please enter the Serial Number of equipment. It is located at back side of panel near input supply.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="nameOfEquipment19" class="form-label">Name of equipment</label>
                          <input type="text" class="form-control" id="nameOfEquipment19" placeholder="Glow Wire Test Apparatus" value={this.state.nameOfEquipment19} onChange={this.nameOfEquipment19ChangeEvent} required={this.state.product_count>=19} />
                          <div class="invalid-feedback">
                            Please enter the Name of equipment.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="natureOfProblem19" class="form-label">Nature of Problem</label>
                          <textarea class="form-control" id="natureOfProblem19" placeholder="Please describe the problem faced in Panel" rows="4" value={this.state.natureOfProblem19} onChange={this.natureOfProblem19ChangeEvent} required={this.state.product_count>=19} ></textarea>
                          <div class="invalid-feedback">
                            Please enter Nature of Problem.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="comments19" class="form-label">Comments<span class="text-muted"> (Optional)</span></label>
                          <textarea class="form-control" id="comments19" placeholder="Feel free to leave any additional comments here" rows="4" value={this.state.comments19} onChange={this.comments19ChangeEvent}></textarea>
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="attachments19" class="form-label">Attachments<span class="text-muted"> (Optional)</span></label>
                          <input class="form-control" type="file" id="attachments19" value={this.state.attachments19} onChange={this.attachments19ChangeEvent} multiple />
                        </div>
                        
                        <hr class="my-4 mb-0" />

                      </div>

                      <div class={`${this.state.product_count >= 20 ? 'row g-3 ms-0 me-0 p-0 collapse show' : 'collapse'}`} >
                        <div class="col-12">
                          <h4 class="mt-3 mb-3">Product Details (20)</h4>
                        </div>

                        <div class="col-12">
                          <label for="jobNumber20" class="form-label">Job Number<span class="text-muted"> (Located below Mains ON/OFF MCB)</span></label>
                          <input type="text" class="form-control" id="jobNumber20" placeholder="2526-JS001" value={this.state.jobNumber20} onChange={this.jobNumber20ChangeEvent} required={this.state.product_count>=20} />
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="serialNumber20" class="form-label">Serial Number<span class="text-muted"> (Located at back side of panel near input supply)</span></label>
                          <input type="text" class="form-control" id="serialNumber20" placeholder="2502001" value={this.state.serialNumber20} onChange={this.serialNumber20ChangeEvent} required={this.state.product_count>=20}  />
                          <div class="invalid-feedback">
                            Please enter the Serial Number of equipment. It is located at back side of panel near input supply.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="nameOfEquipment20" class="form-label">Name of equipment</label>
                          <input type="text" class="form-control" id="nameOfEquipment20" placeholder="Glow Wire Test Apparatus" value={this.state.nameOfEquipment20} onChange={this.nameOfEquipment20ChangeEvent} required={this.state.product_count>=20} />
                          <div class="invalid-feedback">
                            Please enter the Name of equipment.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="natureOfProblem20" class="form-label">Nature of Problem</label>
                          <textarea class="form-control" id="natureOfProblem20" placeholder="Please describe the problem faced in Panel" rows="4" value={this.state.natureOfProblem20} onChange={this.natureOfProblem20ChangeEvent} required={this.state.product_count>=20} ></textarea>
                          <div class="invalid-feedback">
                            Please enter Nature of Problem.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="comments20" class="form-label">Comments<span class="text-muted"> (Optional)</span></label>
                          <textarea class="form-control" id="comments20" placeholder="Feel free to leave any additional comments here" rows="4" value={this.state.comments20} onChange={this.comments20ChangeEvent}></textarea>
                          <div class="invalid-feedback">
                            Please enter the Job Number of equipment. It is located below Mains ON/OFF MCB.
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="attachments20" class="form-label">Attachments<span class="text-muted"> (Optional)</span></label>
                          <input class="form-control" type="file" id="attachments20" value={this.state.attachments20} onChange={this.attachments20ChangeEvent} multiple />
                        </div>
                        
                        <hr class="my-4 mb-0" />

                      </div>

                      <div class={`${this.state.product_count > 1 ? 'col-12 collapse show' : 'collapse'}`} >
                        <button type="button" class="form-control w-100 btn btn-default btn-sm" onClick={this.removeProductEvent}>
                          <span class="bi-dash-circle-fill"></span> Remove product
                        </button>
                      </div>

                      <div class={`${this.state.product_count < 20 ? 'col-12 collapse show' : 'collapse'}`} >
                        <button type="button" class="form-control w-100 btn btn-default btn-sm" onClick={this.addNewProductEvent}>
                          <span class="bi-plus-circle-fill"></span> Add another product
                        </button>
                      </div>

                      <div align="center" class="col-12">
                        <ReCAPTCHA ref={recaptchaRef} sitekey="6LcOFvkhAAAAAB6-6hX2_EEA_sUHbZOoCQyGezgt" onChange={this.captchaOnChange} onErrored={this.captchaOnErrored} onExpired={this.captchaOnExpired}/>
                      </div>

                      <div class="col-12">
                        <button type="submit" class={`${this.state.captcha_validated ? "w-100 btn btn-primary btn-lg mt-2" : "w-100 btn btn-primary btn-lg mt-2 disabled"}`} onClick={this.wasValidatedEvent}>Register</button>
                      </div>
                    </div>
                  </form>
                  
                </div>
                
              </div>
              
            </main>
            
            <ToastContainer />
            <footer class="my-5 pt-5 text-muted text-center text-small">
              <p class="mb-1">&copy; {new Date().getFullYear()} SCR ELEKTRONIKS PRIVATE LIMITED</p>
              {/* <ul class="list-inline">
                <li class="list-inline-item"><a href="#">Privacy</a></li>
                <li class="list-inline-item"><a href="#">Terms</a></li>
                <li class="list-inline-item"><a href="#">Support</a></li>
              </ul> */}
            </footer>
          </div>
        )
    }
  }

  captchaOnChange = async (value) => { 
    this.setState({captcha_validated: true});
  }

  captchaOnErrored = async (value) => { 
    this.setState({captcha_validated: false});
  }

  captchaOnExpired = async (value) => { 
    this.setState({captcha_validated: false});
  }

  wasValidatedEvent = async (e) => { 
    this.setState({was_validated: true});
  }

  saveNewComplaint = async (e) => {
    e.preventDefault();
    const requestOptions = {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + common.getUserInfo().token
      },
      body: JSON.stringify({ 
        name_of_company: this.state.CompanyName, 
        address: this.state.address, 
        country: this.state.country, 
        contact_person_first_name: this.state.contactPersonFirstName, 
        contact_person_last_name: this.state.contactPersonLastName, 
        stateProvince: this.state.stateProvince, 
        contact_person_mobile_number: this.state.contactPersonMobileNumber, 
        contact_person_email_id: this.state.contactPersonEmailId, 
        purchase_manager_first_name: this.state.purchaseManagerFirstName, 
        purchase_manager_last_name: this.state.purchaseManagerLastName, 
        purchase_manager_mobile_number: this.state.purchaseManagerMobileNumber, 
        purchase_manager_email_id: this.state.purchaseManagerEmailId, 
        product_details_1_job_number: this.state.jobNumber1, 
        product_details_1_serial_number: this.state.serialNumber1, 
        product_details_1_name_of_equipment: this.state.nameOfEquipment1, 
        product_details_1_nature_of_problem: this.state.natureOfProblem1, 
        product_details_1_comments: this.state.comments1, 
        product_details_1_attachments: this.state.attachments1, 
        product_details_2_job_number: this.state.jobNumber2, 
        product_details_2_serial_number: this.state.serialNumber2, 
        product_details_2_name_of_equipment: this.state.nameOfEquipment2, 
        product_details_2_nature_of_problem: this.state.natureOfProblem2, 
        product_details_2_comments: this.state.comments2, 
        product_details_2_attachments: this.state.attachments2, 
        product_details_3_job_number: this.state.jobNumber3, 
        product_details_3_serial_number: this.state.serialNumber3, 
        product_details_3_name_of_equipment: this.state.nameOfEquipment3, 
        product_details_3_nature_of_problem: this.state.nameOfEquipment3, 
        product_details_3_comments: this.state.comments3, 
        product_details_3_attachments: this.state.attachments3, 
        product_details_4_job_number: this.state.jobNumber4, 
        product_details_4_serial_number: this.state.serialNumber4, 
        product_details_4_name_of_equipment: this.state.nameOfEquipment4, 
        product_details_4_nature_of_problem: this.state.natureOfProblem4, 
        product_details_4_comments: this.state.comments4, 
        product_details_4_attachments: this.state.attachments4, 
        product_details_5_job_number: this.state.jobNumber5, 
        product_details_5_serial_number: this.state.serialNumber5, 
        product_details_5_name_of_equipment: this.state.nameOfEquipment5, 
        product_details_5_nature_of_problem: this.state.natureOfProblem5, 
        product_details_5_comments: this.state.comments5, 
        product_details_5_attachments: this.state.attachments5, 
        product_details_6_job_number: this.state.jobNumber6, 
        product_details_6_serial_number: this.state.serialNumber6, 
        product_details_6_name_of_equipment: this.state.nameOfEquipment6, 
        product_details_6_nature_of_problem: this.state.natureOfProblem6, 
        product_details_6_comments: this.state.comments6, 
        product_details_6_attachments: this.state.attachments6, 
        product_details_7_job_number: this.state.jobNumber7, 
        product_details_7_serial_number: this.state.serialNumber7, 
        product_details_7_name_of_equipment: this.state.nameOfEquipment7, 
        product_details_7_nature_of_problem: this.state.natureOfProblem7, 
        product_details_7_comments: this.state.comments7, 
        product_details_7_attachments: this.state.attachments7, 
        product_details_8_job_number: this.state.jobNumber8, 
        product_details_8_serial_number: this.state.serialNumber8, 
        product_details_8_name_of_equipment: this.state.nameOfEquipment8, 
        product_details_8_nature_of_problem: this.state.natureOfProblem8, 
        product_details_8_comments: this.state.comments8, 
        product_details_8_attachments: this.state.attachments8, 
        product_details_9_job_number: this.state.jobNumber9, 
        product_details_9_serial_number: this.state.serialNumber9, 
        product_details_9_name_of_equipment: this.state.nameOfEquipment9, 
        product_details_9_nature_of_problem: this.state.natureOfProblem9, 
        product_details_9_comments: this.state.comments9, 
        product_details_9_attachments: this.state.attachments9, 
        product_details_10_job_number: this.state.jobNumber10, 
        product_details_10_serial_number: this.state.serialNumber10, 
        product_details_10_name_of_equipment: this.state.nameOfEquipment10, 
        product_details_10_nature_of_problem: this.state.natureOfProblem10, 
        product_details_10_comments: this.state.comments10, 
        product_details_10_attachments: this.state.attachments10, 
        product_details_11_job_number: this.state.jobNumber11, 
        product_details_11_serial_number: this.state.serialNumber11, 
        product_details_11_name_of_equipment: this.state.nameOfEquipment11, 
        product_details_11_nature_of_problem: this.state.natureOfProblem11, 
        product_details_11_comments: this.state.comments11, 
        product_details_11_attachments: this.state.attachments11, 
        product_details_12_job_number: this.state.jobNumber12, 
        product_details_12_serial_number: this.state.serialNumber12, 
        product_details_12_name_of_equipment: this.state.nameOfEquipment12, 
        product_details_12_nature_of_problem: this.state.natureOfProblem12, 
        product_details_12_comments: this.state.comments12, 
        product_details_12_attachments: this.state.attachments12, 
        product_details_13_job_number: this.state.jobNumber13, 
        product_details_13_serial_number: this.state.serialNumber13, 
        product_details_13_name_of_equipment: this.state.nameOfEquipment13, 
        product_details_13_nature_of_problem: this.state.natureOfProblem13, 
        product_details_13_comments: this.state.comments13, 
        product_details_13_attachments: this.state.attachments13, 
        product_details_14_job_number: this.state.jobNumber14, 
        product_details_14_serial_number: this.state.serialNumber14, 
        product_details_14_name_of_equipment: this.state.nameOfEquipment14, 
        product_details_14_nature_of_problem: this.state.natureOfProblem14, 
        product_details_14_comments: this.state.comments14, 
        product_details_14_attachments: this.state.attachments14, 
        product_details_15_job_number: this.state.jobNumber15, 
        product_details_15_serial_number: this.state.serialNumber15, 
        product_details_15_name_of_equipment: this.state.nameOfEquipment15, 
        product_details_15_nature_of_problem: this.state.natureOfProblem15, 
        product_details_15_comments: this.state.comments15, 
        product_details_15_attachments: this.state.attachments15, 
        product_details_16_job_number: this.state.jobNumber16, 
        product_details_16_serial_number: this.state.serialNumber16, 
        product_details_16_name_of_equipment: this.state.nameOfEquipment16, 
        product_details_16_nature_of_problem: this.state.natureOfProblem16, 
        product_details_16_comments: this.state.comments16, 
        product_details_16_attachments: this.state.attachments16, 
        product_details_17_job_number: this.state.jobNumber17, 
        product_details_17_serial_number: this.state.serialNumber17, 
        product_details_17_name_of_equipment: this.state.nameOfEquipment17, 
        product_details_17_nature_of_problem: this.state.nameOfEquipment17, 
        product_details_17_comments: this.state.comments17, 
        product_details_17_attachments: this.state.attachments17, 
        product_details_18_job_number: this.state.jobNumber18, 
        product_details_18_serial_number: this.state.serialNumber18, 
        product_details_18_name_of_equipment: this.state.nameOfEquipment18, 
        product_details_18_nature_of_problem: this.state.natureOfProblem18, 
        product_details_18_comments: this.state.comments18, 
        product_details_18_attachments: this.state.attachments18, 
        product_details_19_job_number: this.state.jobNumber19, 
        product_details_19_serial_number: this.state.serialNumber19, 
        product_details_19_name_of_equipment: this.state.nameOfEquipment19, 
        product_details_19_nature_of_problem: this.state.natureOfProblem19, 
        product_details_19_comments: this.state.comments19, 
        product_details_19_attachments: this.state.attachments19, 
        product_details_20_job_number: this.state.jobNumber20, 
        product_details_20_serial_number: this.state.serialNumber20, 
        product_details_20_name_of_equipment: this.state.nameOfEquipment20, 
        product_details_20_nature_of_problem: this.state.natureOfProblem20, 
        product_details_20_comments: this.state.comments20, 
        product_details_20_attachments: this.state.attachments20,
      })
    };

    let resRaw = await fetch(common.getBasePath().concat('service/saveNewComplaint'), requestOptions);
    let res = await resRaw.json();
    if(res.error) {
      toast.error("Error occured while Registering Complaint, please try again after some time", {position: "top-right", theme: "dark"});
    } else if(res.invalidData) {
      toast.error("Please enter all data in Alpha Numeric Format only i.e. A..Z or a..z or 0..9", {position: "top-right", theme: "dark"});
    } else {
      toast.success("Complaint Registered Succesfully. Your Complaint ID is ".concat(res.complaintId), {position: "top-right", theme: "dark", autoClose: false});
      this.setState({error: false, was_validated: false, product_count: 1,
      CompanyName: "", address: "", country: "", stateProvince: "", contactPersonFirstName: "", contactPersonLastName: "", contactPersonMobileNumber: "", contactPersonEmailId: "", purchaseManagerFirstName: "", purchaseManagerLastName: "", purchaseManagerMobileNumber: "", purchaseManagerEmailId: "", 
      jobNumber1: "", serialNumber1: "", nameOfEquipment1: "", natureOfProblem1: "", comments1: "", attachments1: "", jobNumber2: "", serialNumber2: "", nameOfEquipment2: "", natureOfProblem2: "", comments2: "", attachments2: "",
      jobNumber3: "", serialNumber3: "", nameOfEquipment3: "", natureOfProblem3: "", comments3: "", attachments3: "", jobNumber4: "", serialNumber4: "", nameOfEquipment4: "", natureOfProblem4: "", comments4: "", attachments4: "",
      jobNumber5: "", serialNumber5: "", nameOfEquipment5: "", natureOfProblem5: "", comments5: "", attachments5: "", jobNumber6: "", serialNumber6: "", nameOfEquipment6: "", natureOfProblem6: "", comments6: "", attachments6: "",
      jobNumber7: "", serialNumber7: "", nameOfEquipment7: "", natureOfProblem7: "", comments7: "", attachments7: "", jobNumber8: "", serialNumber8: "", nameOfEquipment8: "", natureOfProblem8: "", comments8: "", attachments8: "",
      jobNumber9: "", serialNumber9: "", nameOfEquipment9: "", natureOfProblem9: "", comments9: "", attachments9: "", jobNumber10: "", serialNumber10: "", nameOfEquipment10: "", natureOfProblem10: "", comments10: "", attachments10: "",
      jobNumber11: "", serialNumber11: "", nameOfEquipment11: "", natureOfProblem11: "", comments11: "", attachments11: "", jobNumber12: "", serialNumber12: "", nameOfEquipment12: "", natureOfProblem12: "", comments12: "", attachments12: "",
      jobNumber13: "", serialNumber13: "", nameOfEquipment13: "", natureOfProblem13: "", comments13: "", attachments13: "", jobNumber14: "", serialNumber14: "", nameOfEquipment14: "", natureOfProblem14: "", comments14: "", attachments14: "",
      jobNumber15: "", serialNumber15: "", nameOfEquipment15: "", natureOfProblem15: "", comments15: "", attachments15: "", jobNumber16: "", serialNumber16: "", nameOfEquipment16: "", natureOfProblem16: "", comments16: "", attachments16: "",
      jobNumber17: "", serialNumber17: "", nameOfEquipment17: "", natureOfProblem17: "", comments17: "", attachments17: "", jobNumber18: "", serialNumber18: "", nameOfEquipment18: "", natureOfProblem18: "", comments18: "", attachments18: "",
      jobNumber19: "", serialNumber19: "", nameOfEquipment19: "", natureOfProblem19: "", comments19: "", attachments19: "", jobNumber20: "", serialNumber20: "", nameOfEquipment20: "", natureOfProblem20: "", comments20: "", attachments20: "",});
      window.scrollTo(0, 0);
    }
  }

  addNewProductEvent = (e) => {
    this.setState({product_count: this.state.product_count + 1});
  }

  removeProductEvent = (e) => {
    if(this.state.product_count > 1) {
      switch (this.state.product_count) {
        case 2:
          this.setState({jobNumber2: "", serialNumber2: "", nameOfEquipment2: "", natureOfProblem2: "", comments2: "", attachments2: "",});
          break;
        case 3:
          this.setState({jobNumber3: "", serialNumber3: "", nameOfEquipment3: "", natureOfProblem3: "", comments3: "", attachments3: "",});
          break;
        case 4:
          this.setState({jobNumber4: "", serialNumber4: "", nameOfEquipment4: "", natureOfProblem4: "", comments4: "", attachments4: "",});
          break;
        case 5:
          this.setState({jobNumber5: "", serialNumber5: "", nameOfEquipment5: "", natureOfProblem5: "", comments5: "", attachments5: "",});
          break;
        case 6:
          this.setState({jobNumber6: "", serialNumber6: "", nameOfEquipment6: "", natureOfProblem6: "", comments6: "", attachments6: "",});
          break;
        case 7:
          this.setState({jobNumber7: "", serialNumber7: "", nameOfEquipment7: "", natureOfProblem7: "", comments7: "", attachments7: "",});
          break;
        case 8:
          this.setState({jobNumber8: "", serialNumber8: "", nameOfEquipment8: "", natureOfProblem8: "", comments8: "", attachments8: "",});
          break;
        case 9:
          this.setState({jobNumber9: "", serialNumber9: "", nameOfEquipment9: "", natureOfProblem9: "", comments9: "", attachments9: "",});
          break;
        case 10:
          this.setState({jobNumber10: "", serialNumber10: "", nameOfEquipment10: "", natureOfProblem10: "", comments10: "", attachments10: "",});
          break;
        case 11:
          this.setState({jobNumber11: "", serialNumber11: "", nameOfEquipment11: "", natureOfProblem11: "", comments11: "", attachments11: "",});
          break;
        case 12:
          this.setState({jobNumber12: "", serialNumber12: "", nameOfEquipment12: "", natureOfProblem12: "", comments12: "", attachments12: "",});
          break;
        case 13:
          this.setState({jobNumber13: "", serialNumber13: "", nameOfEquipment13: "", natureOfProblem13: "", comments13: "", attachments13: "",});
          break;
        case 14:
          this.setState({jobNumber14: "", serialNumber14: "", nameOfEquipment14: "", natureOfProblem14: "", comments14: "", attachments14: "",});
          break;
        case 15:
          this.setState({jobNumber15: "", serialNumber15: "", nameOfEquipment15: "", natureOfProblem15: "", comments15: "", attachments15: "",});
          break;
        case 16:
          this.setState({jobNumber16: "", serialNumber16: "", nameOfEquipment16: "", natureOfProblem16: "", comments16: "", attachments16: "",});
          break;
        case 17:
          this.setState({jobNumber17: "", serialNumber17: "", nameOfEquipment17: "", natureOfProblem17: "", comments17: "", attachments17: "",});
          break;
        case 18:
          this.setState({jobNumber18: "", serialNumber18: "", nameOfEquipment18: "", natureOfProblem18: "", comments18: "", attachments18: "",});
          break;
        case 19:
          this.setState({jobNumber19: "", serialNumber19: "", nameOfEquipment19: "", natureOfProblem19: "", comments19: "", attachments19: "",});
          break;
        case 20:
          this.setState({jobNumber20: "", serialNumber20: "", nameOfEquipment20: "", natureOfProblem20: "", comments20: "", attachments20: "",});
          break;
      }

      this.setState({product_count: this.state.product_count - 1});
    }
  }

  CompanyNameValueChange = (e) => {
    this.setState({CompanyName: e.target.value});
  }

  addressValueChange = (e) => {
    this.setState({address: e.target.value});
  }

  countryValueChange = (e) => {
    // Reset state when country changes, since the state list depends on the country
    this.setState({country: e.target.value, stateProvince: ""});
  }

  stateProvinceValueChange = (e) => {
    this.setState({stateProvince: e.target.value});
  }

  contactPersonFirstNameValueChange = (e) => {
    if(this.state.purchaseManagerSameAsAbove) {
      this.setState({contactPersonFirstName: e.target.value, purchaseManagerFirstName: e.target.value});
    } else {
      this.setState({contactPersonFirstName: e.target.value});
    }
  }

  contactPersonLastNameValueChange = (e) => {
    if(this.state.purchaseManagerSameAsAbove) {
      this.setState({contactPersonLastName: e.target.value, purchaseManagerLastName: e.target.value});
    } else {
      this.setState({contactPersonLastName: e.target.value});
    }
  }

  contactPersonMobileNumberValueChange = (e) => {
    if(this.state.purchaseManagerSameAsAbove) {
      this.setState({contactPersonMobileNumber: e.target.value, purchaseManagerMobileNumber: e.target.value});
    } else {
      this.setState({contactPersonMobileNumber: e.target.value});
    }
  }

  contactPersonEmailIdValueChange = (e) => {
    if(this.state.purchaseManagerSameAsAbove) {
      this.setState({contactPersonEmailId: e.target.value, purchaseManagerEmailId: e.target.value});
    } else {
      this.setState({contactPersonEmailId: e.target.value});
    }
  }
  
  purchaseManagerSameAsAboveEvent = (e) => {
    this.setState({purchaseManagerSameAsAbove: e.target.checked});
    if(e.target.checked) {
      this.setState({
        purchaseManagerFirstName: this.state.contactPersonFirstName,
        purchaseManagerLastName: this.state.contactPersonLastName,
        purchaseManagerMobileNumber: this.state.contactPersonMobileNumber, 
        purchaseManagerEmailId : this.state.contactPersonEmailId,
      });
    }
  }

  purchaseManagerFirstNameValueChange = (e) => {
    this.setState({purchaseManagerFirstName: e.target.value});
  }

  purchaseManagerLastNameValueChange = (e) => {
    this.setState({purchaseManagerLastName: e.target.value});
  }

  purchaseManagerMobileNumberValueChange = (e) => {
    this.setState({purchaseManagerMobileNumber: e.target.value});
  }

  purchaseManagerEmailIdValueChange = (e) => {
    this.setState({purchaseManagerEmailId: e.target.value});
  }

  jobNumber1ChangeEvent = (e) => {
    this.setState({jobNumber1: e.target.value});
  }

  jobNumber2ChangeEvent = (e) => {
    this.setState({jobNumber2: e.target.value});
  }

  jobNumber3ChangeEvent = (e) => {
    this.setState({jobNumber3: e.target.value});
  }

  jobNumber4ChangeEvent = (e) => {
    this.setState({jobNumber4: e.target.value});
  }

  jobNumber5ChangeEvent = (e) => {
    this.setState({jobNumber5: e.target.value});
  }

  jobNumber6ChangeEvent = (e) => {
    this.setState({jobNumber6: e.target.value});
  }

  jobNumber7ChangeEvent = (e) => {
    this.setState({jobNumber7: e.target.value});
  }

  jobNumber8ChangeEvent = (e) => {
    this.setState({jobNumber8: e.target.value});
  }

  jobNumber9ChangeEvent = (e) => {
    this.setState({jobNumber9: e.target.value});
  }

  jobNumber10ChangeEvent = (e) => {
    this.setState({jobNumber10: e.target.value});
  }

  jobNumber11ChangeEvent = (e) => {
    this.setState({jobNumber11: e.target.value});
  }

  jobNumber12ChangeEvent = (e) => {
    this.setState({jobNumber12: e.target.value});
  }

  jobNumber13ChangeEvent = (e) => {
    this.setState({jobNumber13: e.target.value});
  }

  jobNumber14ChangeEvent = (e) => {
    this.setState({jobNumber14: e.target.value});
  }

  jobNumber15ChangeEvent = (e) => {
    this.setState({jobNumber15: e.target.value});
  }

  jobNumber16ChangeEvent = (e) => {
    this.setState({jobNumber16: e.target.value});
  }

  jobNumber17ChangeEvent = (e) => {
    this.setState({jobNumber17: e.target.value});
  }

  jobNumber18ChangeEvent = (e) => {
    this.setState({jobNumber18: e.target.value});
  }

  jobNumber19ChangeEvent = (e) => {
    this.setState({jobNumber19: e.target.value});
  }

  jobNumber20ChangeEvent = (e) => {
    this.setState({jobNumber20: e.target.value});
  }

  serialNumber1ChangeEvent = (e) => {
    this.setState({serialNumber1: e.target.value});
  }

  serialNumber2ChangeEvent = (e) => {
    this.setState({serialNumber2: e.target.value});
  }

  serialNumber3ChangeEvent = (e) => {
    this.setState({serialNumber3: e.target.value});
  }

  serialNumber4ChangeEvent = (e) => {
    this.setState({serialNumber4: e.target.value});
  }

  serialNumber5ChangeEvent = (e) => {
    this.setState({serialNumber5: e.target.value});
  }

  serialNumber6ChangeEvent = (e) => {
    this.setState({serialNumber6: e.target.value});
  }

  serialNumber7ChangeEvent = (e) => {
    this.setState({serialNumber7: e.target.value});
  }

  serialNumber8ChangeEvent = (e) => {
    this.setState({serialNumber8: e.target.value});
  }

  serialNumber9ChangeEvent = (e) => {
    this.setState({serialNumber9: e.target.value});
  }

  serialNumber10ChangeEvent = (e) => {
    this.setState({serialNumber10: e.target.value});
  }

  serialNumber11ChangeEvent = (e) => {
    this.setState({serialNumber11: e.target.value});
  }

  serialNumber12ChangeEvent = (e) => {
    this.setState({serialNumber12: e.target.value});
  }

  serialNumber13ChangeEvent = (e) => {
    this.setState({serialNumber13: e.target.value});
  }

  serialNumber14ChangeEvent = (e) => {
    this.setState({serialNumber14: e.target.value});
  }

  serialNumber15ChangeEvent = (e) => {
    this.setState({serialNumber15: e.target.value});
  }

  serialNumber16ChangeEvent = (e) => {
    this.setState({serialNumber16: e.target.value});
  }

  serialNumber17ChangeEvent = (e) => {
    this.setState({serialNumber17: e.target.value});
  }

  serialNumber18ChangeEvent = (e) => {
    this.setState({serialNumber18: e.target.value});
  }

  serialNumber19ChangeEvent = (e) => {
    this.setState({serialNumber19: e.target.value});
  }

  serialNumber20ChangeEvent = (e) => {
    this.setState({serialNumber20: e.target.value});
  }

  nameOfEquipment1ChangeEvent = (e) => {
    this.setState({nameOfEquipment1: e.target.value});
  }

  nameOfEquipment2ChangeEvent = (e) => {
    this.setState({nameOfEquipment2: e.target.value});
  }

  nameOfEquipment3ChangeEvent = (e) => {
    this.setState({nameOfEquipment3: e.target.value});
  }

  nameOfEquipment4ChangeEvent = (e) => {
    this.setState({nameOfEquipment4: e.target.value});
  }

  nameOfEquipment5ChangeEvent = (e) => {
    this.setState({nameOfEquipment5: e.target.value});
  }

  nameOfEquipment6ChangeEvent = (e) => {
    this.setState({nameOfEquipment6: e.target.value});
  }

  nameOfEquipment7ChangeEvent = (e) => {
    this.setState({nameOfEquipment7: e.target.value});
  }

  nameOfEquipment8ChangeEvent = (e) => {
    this.setState({nameOfEquipment8: e.target.value});
  }

  nameOfEquipment9ChangeEvent = (e) => {
    this.setState({nameOfEquipment9: e.target.value});
  }

  nameOfEquipment10ChangeEvent = (e) => {
    this.setState({nameOfEquipment10: e.target.value});
  }

  nameOfEquipment11ChangeEvent = (e) => {
    this.setState({nameOfEquipment11: e.target.value});
  }

  nameOfEquipment12ChangeEvent = (e) => {
    this.setState({nameOfEquipment12: e.target.value});
  }

  nameOfEquipment13ChangeEvent = (e) => {
    this.setState({nameOfEquipment13: e.target.value});
  }

  nameOfEquipment14ChangeEvent = (e) => {
    this.setState({nameOfEquipment14: e.target.value});
  }

  nameOfEquipment15ChangeEvent = (e) => {
    this.setState({nameOfEquipment15: e.target.value});
  }

  nameOfEquipment16ChangeEvent = (e) => {
    this.setState({nameOfEquipment16: e.target.value});
  }

  nameOfEquipment17ChangeEvent = (e) => {
    this.setState({nameOfEquipment17: e.target.value});
  }

  nameOfEquipment18ChangeEvent = (e) => {
    this.setState({nameOfEquipment18: e.target.value});
  }

  nameOfEquipment19ChangeEvent = (e) => {
    this.setState({nameOfEquipment19: e.target.value});
  }

  nameOfEquipment20ChangeEvent = (e) => {
    this.setState({nameOfEquipment20: e.target.value});
  }

  natureOfProblem1ChangeEvent = (e) => {
    this.setState({natureOfProblem1: e.target.value});
  }

  natureOfProblem2ChangeEvent = (e) => {
    this.setState({natureOfProblem2: e.target.value});
  }

  natureOfProblem3ChangeEvent = (e) => {
    this.setState({natureOfProblem3: e.target.value});
  }

  natureOfProblem4ChangeEvent = (e) => {
    this.setState({natureOfProblem4: e.target.value});
  }

  natureOfProblem5ChangeEvent = (e) => {
    this.setState({natureOfProblem5: e.target.value});
  }

  natureOfProblem6ChangeEvent = (e) => {
    this.setState({natureOfProblem6: e.target.value});
  }

  natureOfProblem7ChangeEvent = (e) => {
    this.setState({natureOfProblem7: e.target.value});
  }

  natureOfProblem8ChangeEvent = (e) => {
    this.setState({natureOfProblem8: e.target.value});
  }

  natureOfProblem9ChangeEvent = (e) => {
    this.setState({natureOfProblem9: e.target.value});
  }

  natureOfProblem10ChangeEvent = (e) => {
    this.setState({natureOfProblem10: e.target.value});
  }

  natureOfProblem11ChangeEvent = (e) => {
    this.setState({natureOfProblem11: e.target.value});
  }

  natureOfProblem12ChangeEvent = (e) => {
    this.setState({natureOfProblem12: e.target.value});
  }

  natureOfProblem13ChangeEvent = (e) => {
    this.setState({natureOfProblem13: e.target.value});
  }

  natureOfProblem14ChangeEvent = (e) => {
    this.setState({natureOfProblem14: e.target.value});
  }

  natureOfProblem15ChangeEvent = (e) => {
    this.setState({natureOfProblem15: e.target.value});
  }

  natureOfProblem16ChangeEvent = (e) => {
    this.setState({natureOfProblem16: e.target.value});
  }

  natureOfProblem17ChangeEvent = (e) => {
    this.setState({natureOfProblem17: e.target.value});
  }

  natureOfProblem18ChangeEvent = (e) => {
    this.setState({natureOfProblem18: e.target.value});
  }

  natureOfProblem19ChangeEvent = (e) => {
    this.setState({natureOfProblem19: e.target.value});
  }

  natureOfProblem20ChangeEvent = (e) => {
    this.setState({natureOfProblem20: e.target.value});
  }

  comments1ChangeEvent = (e) => {
    this.setState({comments1: e.target.value});
  }

  comments2ChangeEvent = (e) => {
    this.setState({comments2: e.target.value});
  }

  comments3ChangeEvent = (e) => {
    this.setState({comments3: e.target.value});
  }

  comments4ChangeEvent = (e) => {
    this.setState({comments4: e.target.value});
  }

  comments5ChangeEvent = (e) => {
    this.setState({comments5: e.target.value});
  }

  comments6ChangeEvent = (e) => {
    this.setState({comments6: e.target.value});
  }

  comments7ChangeEvent = (e) => {
    this.setState({comments7: e.target.value});
  }

  comments8ChangeEvent = (e) => {
    this.setState({comments8: e.target.value});
  }

  comments9ChangeEvent = (e) => {
    this.setState({comments9: e.target.value});
  }

  comments10ChangeEvent = (e) => {
    this.setState({comments10: e.target.value});
  }

  comments11ChangeEvent = (e) => {
    this.setState({comments11: e.target.value});
  }

  comments12ChangeEvent = (e) => {
    this.setState({comments12: e.target.value});
  }

  comments13ChangeEvent = (e) => {
    this.setState({comments13: e.target.value});
  }

  comments14ChangeEvent = (e) => {
    this.setState({comments14: e.target.value});
  }

  comments15ChangeEvent = (e) => {
    this.setState({comments15: e.target.value});
  }

  comments16ChangeEvent = (e) => {
    this.setState({comments16: e.target.value});
  }

  comments17ChangeEvent = (e) => {
    this.setState({comments17: e.target.value});
  }

  comments18ChangeEvent = (e) => {
    this.setState({comments18: e.target.value});
  }

  comments19ChangeEvent = (e) => {
    this.setState({comments19: e.target.value});
  }

  comments20ChangeEvent = (e) => {
    this.setState({comments20: e.target.value});
  }

  attachments1ChangeEvent = (e) => {
    this.setState({attachments1: e.target.value});
  }

  attachments2ChangeEvent = (e) => {
    this.setState({attachments2: e.target.value});
  }

  attachments3ChangeEvent = (e) => {
    this.setState({attachments3: e.target.value});
  }

  attachments4ChangeEvent = (e) => {
    this.setState({attachments4: e.target.value});
  }

  attachments5ChangeEvent = (e) => {
    this.setState({attachments5: e.target.value});
  }

  attachments6ChangeEvent = (e) => {
    this.setState({attachments6: e.target.value});
  }

  attachments7ChangeEvent = (e) => {
    this.setState({attachments7: e.target.value});
  }

  attachments8ChangeEvent = (e) => {
    this.setState({attachments8: e.target.value});
  }

  attachments9ChangeEvent = (e) => {
    this.setState({attachments9: e.target.value});
  }

  attachments10ChangeEvent = (e) => {
    this.setState({attachments10: e.target.value});
  }

  attachments11ChangeEvent = (e) => {
    this.setState({attachments11: e.target.value});
  }

  attachments12ChangeEvent = (e) => {
    this.setState({attachments12: e.target.value});
  }

  attachments13ChangeEvent = (e) => {
    this.setState({attachments13: e.target.value});
  }

  attachments14ChangeEvent = (e) => {
    this.setState({attachments14: e.target.value});
  }

  attachments15ChangeEvent = (e) => {
    this.setState({attachments15: e.target.value});
  }

  attachments16ChangeEvent = (e) => {
    this.setState({attachments16: e.target.value});
  }

  attachments17ChangeEvent = (e) => {
    this.setState({attachments17: e.target.value});
  }

  attachments18ChangeEvent = (e) => {
    this.setState({attachments18: e.target.value});
  }

  attachments19ChangeEvent = (e) => {
    this.setState({attachments19: e.target.value});
  }

  attachments20ChangeEvent = (e) => {
    this.setState({attachments20: e.target.value});
  }

}

export default RegisterNewComplaint;
